const messages = {
  es: {
    translations: {
      signup: {
        title: "Registro",
        plan: {
          selected: "Plan Seleccionado",
        },
        toasts: {
          success:
            "¡El usuario ha sido creado satisfactoriamente! ¡Ahora inicia sesión!",
          fail: "Error creando el usuario. Verifica la data reportada.",
        },
        errors: {
          registrationAlreadyExists: "Ya existe un registro asociado al correo o documento informado.",
          loginLink: "Si ya tienes una cuenta, inicia sesión para continuar.",
          loginButton: "Iniciar sesión",
        },
        country: {
          label: "País",
        },
        form: {
          name: "Nombre",
          email: "Correo Electrónico",
          password: "Contraseña",
          company: "Nombre de la Empresa",
          companyName: "Razón Social",
          tradeName: "Nombre Comercial",
          personName: "Nombre completo",
          phone: "Whatsapp (COD + NÚMERO)",
        },
        buttons: {
          continue: "Continuar",
          submit: "Regístrate",
          login: "¿Ya tienes una cuenta? ¡Inicia sesión!",
        },
        step2: {
          reviewTitle: "Revisa tus datos",
          manualTitle: "Completa tu registro",
          foundDataMessage: "Encontramos algunos datos asociados a tu documento.",
          documentLabel: "Documento",
          backButton: "Volver y cambiar documento",
        },
      },
      login: {
        title: "Inicio de Sesión",
        welcome: "Bienvenido de nuevo",
        loginInstruction: "Introduce tus datos para acceder a tu cuenta",
        form: {
          email: "Correo Electrónico",
          password: "Contraseña",
          button: "Ingresar",
        },
        buttons: {
          submit: "Ingresa",
          register: "¿No tienes cuenta? ¡Regístrate!",
        },
      },
      companies: {
        title: "Registrar Empresa",
        form: {
          name: "Nombre de la Empresa",
          plan: "Plan",
          token: "Token",
          submit: "Registrar",
          success: "Empresa creada con éxito!",
        },
      },
      auth: {
        toasts: {
          success: "¡Inicio de sesión exitoso!",
        },
        dueDate: {
          expiration: "Suscripción caducará en",
          days: "días!",
          day: "día!",
          expirationToday: "Su suscripción termina hoy!",
        },
        token: "Token",
      },
      dashboard: {
        filters: "Filtros",
        filter: "FILTRAR ",
        tabs: {
          indicators: "Indicadores",
          assessments: "Evaluaciones",
          attendants: "Agentes",
        },
        charts: {
          perDay: {
            title: "Tickets hoy: ",
          },
        },
        cards: {
          inAttendance: "Atención actual",
          waiting: "Esperando",
          activeAttendants: "Agentes Activos",
          finalized: "Finalizados",
          newContacts: "Nuevos Contactos",
          totalReceivedMessages: "Total de Mensajes Recibidas",
          totalSentMessages: "Total de Mensajes Enviadas",
          averageServiceTime: "T.P. de Atención",
          averageWaitingTime: "T.P. de Espera",
          status: "Status (Actual)",
        },
        users: {
          name: "Nombre",
          numberAppointments: "Total de tickets",
          statusNow: "Actual",
          totalCallsUser: "Total de atención por usuario",
          totalAttendances: "Total de atenciones",
        },
        date: {
          initialDate: "Fecha Inicial",
          finalDate: "Fecha Final",
        },
        licence: {
          available: "Disponíble hasta",
        },
        assessments: {
          totalCalls: "Total de Tickets",
          callsWaitRating: "Tickets aguardando evaluación",
          callsWithoutRating: "Ticket sin evaluación",
          ratedCalls: "Tickets evaluados",
          evaluationIndex: "Índice de evaluación",
          score: "Puntaje",
          prosecutors: "Promotores",
          neutral: "Neutrales",
          detractors: "Dectratores",
        },
      },
      reports: {
        title: "Reporte de Pesquisas Realizadas",
        operator: "Agente",
        period: "Período",
        until: "Hasta",
        date: "Fecha",
        reportTitle: "Relatorios",
        calls: "Atenciones",
        search: "Pesquisas",
        durationCalls: "Duración de la atención",
        grupoSessions: "Atención en grupos grupos",
        startDate: "Fecha de inicio",
        endDate: "Fecha de finalización",
        table: {
          id: "Ticket",
          user: "Usuario",
          dateOpen: "Fecha de Apertura",
          dateClose: "Fecha de Cierre",
          NPS: "NPS",
          status: "Estado",
          whatsapp: "Conexión",
          queue: "Cola",
          actions: "Acciones",
          lastMessage: "Últ. Mensaje",
          contact: "Cliente",
          supportTime: "Tiempo de Atención",
        },
        buttons: {
          filter: "Aplicar Filtro",
          onlyRated: "Solo Evaluados",
        },
        groupTicketsReports: {
          timezone: "America/Monterrey",
          msgToast: "Generando relatorio compactado, por favor espere.",
          errorToast: "Erro ao generar relatorio",
          back: "Volver",
          groupServiceReport: "Relatorio de Atención en Grupos",
          loading: "Cargando...",
          contact: "Contacto",
          dateOpen: "Fecha de Apertura",
          dateLastUpdated: "Fecha Ultima Actualización",
          agent: "Agente",
          agentClosed: "Agente(cerró)",
          waitingAssistance: "Esperando atención",
          process: "En proceso",
        },
        researchReports: {
          response: "respuesta",
          active: "(Activa)",
          inactive: "(Inactiva)",
          quantity: "Cantidade",
          percentage: "porcentaje",
          title: "Relatorio de Pesquisas Realizadas",
          activeSearch: "Pesquisa activa",
          inactiveSearch: "Pesquisa inactiva",
        },
        ticketDurationDetail: {
          msgToast: "Generando relatorio compactado, por favor espere.",
          title: "Relatorio de Duración de la Atención",
          startService: "Início de la Atención",
          lastUpdated: "Última actualización",
          lastAgent: "Último agente",
          durationFinished: "Duración después de finalizado",
        },
        ticketDuration: {
          title: "Relatorio de Duración de Atención",
          contact: "Contacto",
          open: "Abiertos",
          pending: "Pendientes",
          finished: "Finalizados",
          durationFinished: "Duración de los finalizados",
          durationAfterFinished: "Duración después de finalizado",
          actions: "Acciones",
        },
        ticketReports: {
          msgToast: "Generando relatorio compactado, por favor aguarde.",
          title: "Relatrio de Atención",
        },
        exportExcel: {
          title: "Reportes de Atención",
          startDate: "Fecha inicial",
          endDate: "Fecha final",
          notInformed: "No informado",
          columns: {
            id: "ID",
            connection: "Conexión",
            contact: "Contacto",
            user: "Usuario",
            queue: "Fila",
            status: "Estado",
            lastMessage: "Último Mensaje",
            openDate: "Fecha Apertura",
            openTime: "Hora Apertura",
            closeDate: "Fecha Cierre",
            closeTime: "Hora Cierre",
            supportTime: "Tiempo de Atención",
            nps: "NPS",
          },
        },
        pdf: {
          title: "Relación de Atenciones Realizadas",
          exportTitle: "Relación de Atenciones en Grupos Realizadas",
        },
      },
      todo: {
        newTask: "Nueva Tarea",
        add: "Agregar",
        task: "Tareas",
      },
      contactImportWpModal: {
        title: "Exportar Contactos para Excel",
        buttons: {
          downloadModel: "Download - modelo de excel para importación",
          closed: "Cerrar",
          import: "Seleccione el archivo de excel para importar los Contactos",
        },
      },
      connections: {
        title: "Conexiones",
        waitConnection: "Espere... Las conexiones serán reiniciadas!",
        newConnection: "Nueva Conexión",
        restartConnections: "Reiniciar Conexiones",
        callSupport: "Soporte",
        connectYourServiceChannelsToReceiveMessagesAndStartConversationsWithYourCustomers:
          " Conecta tus canales de atención para recibir mensajes e iniciar conversaciones con tus clientes.",
        client: "Cliente",
        connectedConnections: "Conexiones conectadas",
        disconnectedConnections: "Conexiones desconectadas",
        totalConnections: "Total de conexiones",
        total: "Total",
        connections: " Conexiones:",
        toasts: {
          deleted:
            "¡La conexión de WhatsApp ha sido borrada satisfactoriamente!",
          closedimported:
            "Estamos cerrando los tickets importados, por favor espere.",
        },
        confirmationModal: {
          closedImportedTitle: "Cerrar tickets importados",
          closedImportedMessage:
            "¿Seguro? Todos los tickets importados seran cerrados.",
          deleteTitle: "Borrar",
          deleteMessage: "¿Estás seguro? Este proceso no puede ser revertido.",
          disconnectTitle: "Desconectar",
          disconnectMessage: "Estás seguro? Deberá volver a leer el código QR",
        },
        buttons: {
          add: "Agrega WhatsApp",
          disconnect: "Desconectar",
          tryAgain: "Inténtalo de nuevo",
          qrcode: "QR CODE",
          newQr: "Nuevo QR CODE",
          closedImported: "Cerrar todos los tickets Importados",
          preparing: "Preparando mensajes para importación",
          importing: "Importando Mensajes del WhatsApp",
          processed: "Processado",
          in: "de",
          connecting: "Conectando",
        },
        typography: {
          processed: "Processado",
          in: "de",
          date: "Fecha del mensaje",
        },
        tooltips: {
          edit: "Editar conexión",
          delete: "Eliminar conexión",
          syncTemplates: "Sincronizar plantillas",
          copyWebhook: "Copiar webhook para Meta",
          transferTickets: "Transferir tickets entre conexiones",
          restartConnections: "Reiniciar todas las conexiones",
          callSupport: "Llamar soporte vía WhatsApp",
          newConnection: "Agregar nueva conexión",
          qrcode: "Mostrar código QR para conectar",
          tryAgain: "Intentar reconectar",
          newQr: "Generar nuevo código QR",
          disconnect: "Desconectar sesión",
          connecting: "Espere, conectando...",
          defaultConnection: "Esta es la conexión predeterminada",
          channelWhatsapp: "Canal: WhatsApp",
          channelWhatsappOfficial: "Canal: WhatsApp Oficial (API Cloud)",
          channelFacebook: "Canal: Facebook Messenger",
          channelInstagram: "Canal: Instagram Direct",
          closedImported: "Cerrar todos los tickets que fueron importados del historial",
          preparing: "Preparando mensajes para importación...",
          importMessages: "Importar historial de mensajes de WhatsApp",
        },
        toolTips: {
          opening: {
            title: "Esperando conexión",
            content: "El sistema está intentando conectar. Espere o haga clic en 'Nuevo QR Code' para generar un nuevo código.",
          },
          disconnected: {
            title: "No se pudo iniciar la sesión de WhatsApp",
            content:
              "Asegúrese de que su teléfono celular esté conectado a Internet y vuelva a intentarlo o solicite un nuevo código QR",
          },
          qrcode: {
            title: "Esperando la lectura del código QR",
            content:
              "Haga clic en el botón 'CÓDIGO QR' y lea el Código QR con su teléfono celular para iniciar la sesión",
          },
          connected: {
            title: "Desconectar sesión",
          },
          timeout: {
            title: "Se perdió la conexión con el teléfono celular",
            content:
              "Asegúrese de que su teléfono celular esté conectado a Internet y que WhatsApp esté abierto, o haga clic en el botón 'Desconectar' para obtener un nuevo código QR",
          },
          restarting: {
            title: "Reiniciando conexión",
            content: "La conexión se está reiniciando automáticamente. Espere un momento...",
          },
        },
        table: {
          name: "Nombre",
          status: "Estado",
          lastUpdate: "Última Actualización",
          default: "Por Defecto",
          actions: "Acciones",
          session: "Sesión",
          number: "Número de Whatsapp",
          receiveComments: "Recibir Comentarios",
        },
        receiveComments: {
          enabled: "Recepción de comentarios habilitada",
          disabled: "Recepción de comentarios deshabilitada",
          tooltip: {
            enabled: "Los comentarios se están recibiendo. Haga clic para deshabilitar.",
            disabled: "Los comentarios no se están recibiendo. Haga clic para habilitar.",
          },
        },
      },
      showTicketOpenModal: {
        title: {
          header: "Servicio existente",
        },
        form: {
          message: "Hay un ticket abierto para este contacto:",
          user: "Agente",
          queue: "Fila",
          messageWait: "Este contacto ya está en espera.",
        },
      },
      showTicketLogModal: {
        title: {
          header: "Historico",
        },
        options: {
          create: "Ticket creado.",
          chatBot: "ChatBot iniciado.",
          queue: " - Fila definida.",
          open: "iniciou la atención.",
          access: "accesó el ticket.",
          transfered: "transferió el ticket.",
          receivedTransfer: "recibió el ticket transferido.",
          pending: "regresó a la fila.",
          closed: "cerró el ticket",
          reopen: "abrió el ticket",
        },
      },
      whatsappModal: {
        title: {
          add: "Agrega WhatsApp",
          edit: "Edita WhatsApp",
        },
        tabs: {
          general: "Geral",
          messages: "Mensajes",
          assessments: "Evaluaciones",
          integrations: "Integraciones",
          schedules: "Horario de trabajo",
        },
        form: {
          importOldMessagesEnable: "Importar mensajes del celular",
          importOldMessages: "Fecha de inicio",
          importRecentMessages: "Fecha Final",
          importOldMessagesGroups: "Importar mensajes de grupo",
          closedTicketsPostImported: "Cerrar tickets después de la importación",
          name: "Nombre",
          queueRedirection: "Redirección de Fila",
          queueRedirectionDesc:
            "Seleccione una fila para los contactos que no tienen una fila para redirigir",
          default: "Por Defecto",
          group: "Permitir grupos",
          timeSendQueue: "Tiempo en minutos para redireccionar a la fila",
          importAlert:
            "ATENCIÓN: Guardando, su conexión será cerrada, usted tendrá que volver a leer el QR Code para importar los mensajes",
          groupAsTicket: "Grupos como Ticket",
          timeCreateNewTicket: "Iniciar un nuevo ticket en *n* minutos",
          maxUseBotQueues:
            "Cantidad máxima de veces que el chatbot va a ser enviado",
          timeUseBotQueues: "Tiempo en minutos para nuevo envío del chatbot",
          expiresTicket: "Cerrar chats abiertos após *n* horas",
          expiresTicketNPS:
            "Cerrar chats aguardando la evaluacion luego de x minutos",
          maxUseBotQueuesNPS:
            "Cantidad máxima de veces que la evaluación será enviada",
          closeLastMessageOptions1: "Del Agente/Cliente",
          closeLastMessageOptions2: "Del Agente",
          outOfHoursMessage: "Mensaje fuera de horario de atención",
          greetingMessage: "Mensaje de saludo",
          complationMessage: "Mensaje de conclusión",
          lgpdLinkPrivacy: "Link para políticas de privacidad",
          lgpdMessage: "Mensaje inicial de LPD",
          lgpdDeletedMessages: "Ofuscar mensaje borrada por el contacto",
          lgpdSendMessage: "Siempre solicitar confirmación del contacto",
          ratingMessage: "Mensaje de evaluación - Rango de 0 a 10",
          token: "Token para integración externa",
          sendIdQueue: "Fila",
          inactiveMessage: "Mensaje de inactividad",
          timeInactiveMessage:
            "Tiempo em minutos para el envío del aviso de inactividad",
          whenExpiresTicket:
            "Cerrar chats abiertos cuando el último mensaje sea",
          expiresInactiveMessage: "Mensaje al cerrar por inactividade",
          prompt: "Prompt",
          triggerIntegrationOnClose:
            "Integración de activadores al cerrar un ticket",
          enableIntegration: "Activadore Integración",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        menuItem: {
          enabled: "Activado",
          disabled: "Desactivado",
          minutes: "minutos",
        },
        success: "WhatsApp guardado satisfactoriamente.",
        errorSendQueue:
          "Además del tiempo debes seleccinar una fila para redirecionar. Se necesitan los dos campos.",
        errorExpiresNPS:
          "Es necesario llenar el tiempo para la evaluación para el NPS.",
      },
      qrCode: {
        title: "Conectar WhatsApp",
        message: "Lée el código QR para empezar la sesión.",
        waiting: "Esperando código QR...",
      },
      contacts: {
        title: "Contactos",
        profileImageTitle: "Foto de Perfil",
        toasts: {
          deleted: "¡Contacto borrado satisfactoriamente!",
        },
        searchPlaceholder: "Buscar...",
        conversationFlows: "La conversación fluye",
        addFlow: "Agregar Flujo",
        editFlow: "Editar Flujo ",
        confirmationModal: {
          deleteTitle: "Borrar",
          importTitlte: "Importar contactos",
          exportContact: "Exportar contactos",
          deleteMessage:
            "¿Estás seguro que deseas borrar este contacto? Todos los tickets relacionados se perderán.",
          blockContact: "¿Estás seguro que quieres bloquear este contacto?",
          unblockContact:
            "¿Estás seguro que quieres desbloquear este contacto?",
          importMessage: "¿Quieres importar todos los contactos del teléfono?",
          importChat: "Importar Conversaciones",
          wantImport:
            "¿Quieres importar todas las conversaciones del teléfono?",
        },
        buttons: {
          import: "Importar Contactos",
          add: "Agregar Contacto",
          export: "Exportar Contacto",
        },
        table: {
          name: "Nombre",
          whatsapp: "WhatsApp",
          email: "Correo Electrónico",
          actions: "Acciones",
          lastMessage: "Ultimo Mensaje",
        },
        tooltips: {
          sendMessage: "Enviar mensaje por WhatsApp",
          edit: "Editar contacto",
          block: "Bloquear contacto",
          unblock: "Desbloquear contacto",
          delete: "Eliminar contacto",
        },
        menu: {
          importYourPhone: "Importar del celular por default",
          importToExcel: "Importar / Exportar del Excel",
          importexport: "IMPORTAR / EXPORTAR",
        },
        fixContactsLid: {
          title: "Corrección de Contactos (LID)",
          button: "Corregir LID",
          tooltip: "Corregir contactos duplicados donde LID fue guardado como número",
          start: "Iniciar",
          close: "Cerrar",
          details: "Detalles",
          steps: {
            idle: "Esperando",
            starting: "Iniciando",
            identifying: "Identificando contactos",
            finding: "Buscando contactos reales",
            merging: "Fusionando contactos",
            completed: "Completado",
            error: "Error",
          },
        },
        importProgress: {
          title: "Importar Contactos del Dispositivo",
          starting: "Iniciando importación...",
          searching: "Buscando contactos en el dispositivo...",
          importing: "Importando contactos...",
          processing: "Procesando",
          of: "de",
          contacts: "contactos",
          completed: "¡Importación completada!",
          created: "contactos creados",
          updated: "contactos actualizados",
          skipped: "ignorados",
          error: "Error en la importación",
          closeAndRefresh: "Cerrar y Actualizar",
          close: "Cerrar",
        },
      },
      forwardMessage: {
        text: "Reenviada",
      },
      forwardMessageModal: {
        title: "Reenviar mensaje",
        buttons: {
          ok: "Reenviar",
        },
      },
      promptModal: {
        form: {
          name: "Nombre",
          prompt: "Prompt",
          voice: "Voz",
          max_tokens: "Máximo de Tokens en la respuesta",
          temperature: "Temperatura",
          apikey: "API Key",
          max_messages: "Máximo de mensajes del Historico",
          voiceKey: "Llave de la API de la Voz",
          voiceRegion: "Región de la Voz",
        },
        success: "Prompt guardado",
        title: {
          add: "Agregar Prompt",
          edit: "Editar Prompt",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
      },
      prompts: {
        title: "Prompts",
        table: {
          name: "Nombre",
          queue: "Sector/Fila",
          max_tokens: "Máximo Tokens Respuestas",
          actions: "Acciones",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "¿Estás seguro? ¡Esta acción no se puede revertir!",
        },
        buttons: {
          add: "Agregar Prompt",
        },
      },
      contactModal: {
        title: {
          add: "Agregar contacto",
          edit: "Editar contacto",
        },
        form: {
          mainInfo: "Detalles del contacto",
          extraInfo: "Información adicional",
          name: "Nombre",
          number: "Número de Whatsapp",
          email: "Correo Electrónico",
          extraName: "Nombre del Campo",
          extraValue: "Valor",
          chatBotContact: "Desactivar chatbot para este contacto",
          termsLGDP: "Términos P.P. aceptados en:",
          allTicket: "Visualizar tickets sin fila",
          allowGroup: "Permitir grupos",
        },
        buttons: {
          addExtraInfo: "Agregar información",
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        success: "Contacto guardado satisfactoriamente.",
        walletLinked: "¡Contacto vinculado a su billetera exitosamente!",
        walletError: "El usuario no tiene colas asociadas",
        saveFirst: "El contacto debe guardarse primero",
      },
      wallets: {
        title: "Billeteras de Contactos",
        searchPlaceholder: "Buscar contactos...",
        filterByUser: "Filtrar por Usuario",
        allUsers: "Todos los usuarios",
        contact: "Contacto",
        user: "Usuario",
        queue: "Cola",
        phone: "Teléfono",
        email: "Email",
        actions: "Acciones",
        editWallet: "Editar Billetera",
        selectUser: "Seleccionar Usuario",
        selectQueue: "Seleccionar Cola",
        selectUserAndQueue: "Seleccione un usuario y una cola",
        cancel: "Cancelar",
        save: "Guardar",
        confirmDeleteTitle: "Confirmar Eliminación",
        confirmDeleteMessage:
          "¿Está seguro de que desea eliminar este contacto de la billetera?",
        deleteSuccess: "¡Contacto eliminado de la billetera exitosamente!",
        updateSuccess: "¡Billetera actualizada exitosamente!",
      },
      queueModal: {
        title: {
          queueData: "Datos de la fila",
          text: "Horarios de atención",
          add: "Agregar fila",
          edit: "Editar fila",
          confirmationDelete:
            "¿Está seguro? Todas las opciones integradas también se eliminarán.",
        },
        form: {
          name: "Nombre",
          color: "Color",
          orderQueue: "Orden de la fila (Bot)",
          rotate: "Rotativo",
          timeRotate: "Tiempo de Rotación",
          greetingMessage: "Mensaje de saludo",
          complationMessage: "Mensaje de cierre",
          outOfHoursMessage: "Mensaje fuera de horario de atención",
          token: "Token",
          integrationId: "Integración",
          fileListId: "Listado de archivos",
          closeTicket: "Cerrar ticket",
          queueType: "Tipo de menu",
          message: "Mensaje de respuesta",
          queue: "Fila para transferencia",
          integration: "Integración",
          file: "Listado de archivos",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Editar",
          cancel: "Cancelar",
        },
        bot: {
          title: "Opciones",
          toolTipTitle: "Agregue las opciones para construir un chatbot",
          toolTip:
            "Si solo hay una opción, se elegirá automáticamente, lo que hará que el bot responda con el mensaje de la opción y avance.",
          selectOption: "Seleccione una opción",
          text: "Texto",
          attendent: "Agente",
          queue: "Fila",
          integration: "Integranción",
          file: "Archivo",
          toolTipMessageTitle:
            "El mensaje es obligatorio para pasar al siguiente nivel",
          toolTipMessageContent:
            "El mensaje es obligatorio para pasar al siguiente nivel",
          selectUser: "Seleccione un Usuario",
          selectQueue: "Seleccione una Fila",
          selectIntegration: "Seleccione um Integración",
          addOptions: "Agregar opciones",
        },
        serviceHours: {
          dayWeek: "Día",
          startTimeA: "Hora de Inicio",
          endTimeA: "Hora del término",
          startTimeB: "Hora de Inicio",
          endTimeB: "Hora del término",
          monday: "Lunes",
          tuesday: "Martes",
          wednesday: "Miércoles",
          thursday: "Jueves",
          friday: "Viernes",
          saturday: "Sabado",
          sunday: "Domingo",
        },
      },
      queueIntegrationModal: {
        title: {
          add: "Agregar proyecto",
          edit: "Editar proyecto",
        },
        form: {
          id: "ID",
          type: "Tipo",
          name: "Nombre",
          projectName: "Nombre del Proyecto",
          language: "Idioma",
          jsonContent: "JsonContent",
          urlN8N: "URL",
          typebotSlug: "Typebot - Slug",
          typebotExpires: "Tiempo en minutos para expirar una conversación",
          typebotKeywordFinish: "Palabra para finalizar la conversación",
          typebotUnknownMessage: "Mensaje de opción invalida",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
          test: "Probar Bot",
        },
        messages: {
          testSuccess: "¡Integración testada con éxito!",
          addSuccess: "¡Integración agregada con éxito!",
          editSuccess: "¡Integración editada con éxito!",
        },
      },
      userModal: {
        warning:
          "Para importar los mensajes por favor vuelva a leer el QRCode.",
        title: {
          add: "Agregar usuario",
          edit: "Editar usuario",
          updateImage: "Actualizar Imagen",
          removeImage: "Excluir Imagen",
        },
        form: {
          name: "Nombre",
          email: "Correo Electrónico",
          password: "Contraseña",
          farewellMessage: "Mensaje de despedida",
          profile: "Perfil",
          startWork: "Inicio del Horario",
          endWork: "Final del Horario",
          whatsapp: "Conexión Defautl",
          allTicketEnable: "Activado",
          allTicketDisable: "Desactivado",
          allTicket: "Visualizar mensajes sin fila",
          allowGroup: "Permitir Grupos",
          defaultMenuOpen: "Abierto",
          defaultMenuClosed: "Cerrado",
          defaultMenu: "Menu Estándar",
          defaultTheme: "Tema Estándar",
          defaultThemeDark: "Oscuro",
          defaultThemeLight: "Claro",
          allHistoric: "Ver historicos",
          allHistoricEnabled: "Activado",
          allHistoricDisabled: "Desactivado",
          allUserChat: "Ver conversación de otros usuarios",
          userClosePendingTicket: "Permitir cerrar tickets pendientes",
          showDashboard: "Ver Dashboard",
        },
        tabs: {
          general: "General",
          permissions: "Permissos",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
          addImage: "Agregar Imagen",
          editImage: "Editar Imagen",
        },
        success: "Usuario guardado satisfactoriamente.",
      },
      companyModal: {
        title: {
          add: "Agregar empresa",
          edit: "Editar empresa",
        },
        form: {
          name: "Nombre",
          email: "Correo electrónico",
          passwordDefault: "Contraseña",
          numberAttendants: "Usuarios",
          numberConections: "Conexiones",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        success: "La Empresa fue guardada satisfactoriamente.",
      },
      scheduleModal: {
        title: {
          add: "Nuevo Programa",
          edit: "Editar Programa",
          message: "Mensaje",
        },
        form: {
          body: "Mensaje",
          contact: "Contacto",
          sendAt: "Fecha del Programa",
          sentAt: "Fecha de Envío",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        success: "Programa guardado satisfactoriamente.",
      },
      tagModal: {
        title: {
          add: "Nueva Tag",
          edit: "Editar Tag",
          addKanban: "Nueva Lane",
          backToKanban: "VOLVER A KANBAN",
          editKanban: "Editar Lane",
        },
        form: {
          name: "Nombre",
          color: "Color",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        success: "Tag guardada satisfactoriamente.",
        successKanban: "Lane guardada satisfactoriamente.",
      },
      fileModal: {
        title: {
          add: "Agregar menú de evaluación",
          edit: "Editar menú de evaluación",
        },
        buttons: {
          okAdd: "Guardar",
          okEdit: "Editar",
          cancel: "Cancelar",
          fileOptions: "Agregar archivo",
        },
        form: {
          name: "Nombre",
          message: "Mensaje de Evaluación",
          options: "Opciones de Evaluación",
          extraName: "Nombre de la opción",
          extraValue: "Valor de la opción",
        },
        success: "Evaluación guardada satisfactoriamente.",
      },
      chat: {
        noTicketMessage: "Selecciona un ticket para empezar a chatear.",
      },
      uploads: {
        titles: {
          titleUploadMsgDragDrop:
            "⬇️ ARRASTRE Y SUELTE LOS ARCHIVOS EN EL CAMPO ⬇️",
          titleFileList: "Listado de archivo(s)",
        },
      },
      chatInternal: {
        new: "Nuevo grup",
        modal: {
          conversation: "Inicio",
          title: "Título",
          filterUsers: "Filtro por Usuarios",
          cancel: "Cerrar",
          save: "Guardar",
        },
        modalDelete: {
          title: "Excluir Chat",
          message: "Esta acción no se puede revertir, ¿confirmar?",
        },
      },
      ticketsManager: {
        questionCloseTicket: "¿Quieres cerrar todos los tickets?",
        yes: "SI",
        not: "NO",
        buttons: {
          newTicket: "Nuevo",
          resolvAll: "Resolver Todos",
          close: "Cerrar",
          new: "Nuevo",
        },
      },
      ticketsQueueSelect: {
        placeholder: "Filas",
      },
      tickets: {
        inbox: {
          closedAllTickets: "¿Cerrar todos los tickets?",
          closedAll: "Cerrar Todos",
          newTicket: "Nuevo Ticket",
          yes: "SI",
          no: "NO",
          open: "Abiertos",
          resolverd: "Resueltos",
        },
        toasts: {
          deleted: "El ticket en el que estabas ha sido borrado.",
        },
        notification: {
          message: "Mensaje de",
        },
        tabs: {
          open: { title: "Bandeja" },
          closed: { title: "Resueltos" },
          search: { title: "Buscar" },
        },
        search: {
          placeholder: "Buscar tickets y mensajes.",
          filterConections: "Filtro por Conexión",
          filterConectionsOptions: {
            open: "Abierto",
            closed: "Cerrado",
            pending: "Pendiente",
          },
          filterUsers: "Filtro por usuarios",
          filterContacts: "Filtrar por Contactos",
          ticketsPerPage: "Entradas por página",
        },
        buttons: {
          showAll: "Todos",
          returnQueue: "Regresar a la Fila",
          scredule: "Programar",
          deleteTicket: "Borrar Ticket",
        },
        closedTicket: {
          closedMessage: "Cerrar CON un mensaje de despedida",
          closedNotMessage: "Cerrar SIN un mensaje de despedida",
        },
      },
      transferTicketModal: {
        title: "Transferir Ticket",
        fieldLabel: "Escriba para buscar usuarios",
        fieldQueueLabel: "Transferir para fila",
        fieldQueuePlaceholder: "Seleccione una fila",
        fieldWhatsapp: "Seleccione un whatsapp",
        noOptions: "No se encontraron usuarios con ese nombre",
        msgTransfer:
          "Observación - los mensajes internos, no serán visualizados por el cliente.",
        buttons: {
          ok: "Transferir",
          cancel: "Cancelar",
        },
      },
      chatInternal: {
        new: "Nuevo grup",
        modal: {
          conversation: "Inicio",
          title: "Título",
          filterUsers: "Filtro por Usuarios",
          cancel: "Cerrar",
          save: "Guardar",
        },
        modalDelete: {
          title: "Excluir Chat",
          message: "Esta acción no se puede revertir, ¿confirmar?",
        },
      },
      ticketsList: {
        called: "Entradas",
        today: "Hoy",
        missedCall: "Llamada de voz/vídeo perdida a las",
        pendingHeader: "Esperando",
        assignedHeader: "Trabajando en",
        allHeader: "Todos",
        groupingHeader: "Grupos",
        noTicketsTitle: "¡Nada acá!",
        noTicketsMessage:
          "No se encontraron tickets con este estado o término de búsqueda",
        noQueue: "Sin Fila",
        buttons: {
          accept: "Aceptar",
          cancel: "Cancelar",
          start: "Iniciar",
          closed: "Cerrar",
          reopen: "Reabrir",
          transfer: "Transferir",
          ignore: "Ignorar",
          exportAsPDF: "Exportar para PDF",
        },
        acceptModal: {
          title: "Aceptar Chat",
          queue: "Seleccionar tag",
        },
      },
      newTicketModal: {
        title: "Crear Ticket",
        fieldLabel: "Escribe para buscar un contacto",
        add: "Agregar",
        buttons: {
          ok: "Guardar",
          cancel: "Cancelar",
        },
      },
      SendContactModal: {
        title: "Enviar contacto",
        fieldLabel: "Buscar contacto",
        add: "Agregar",
        buttons: {
          ok: "Enviar",
          cancel: "Cancelar",
        },
      },
      mainDrawer: {
        listItems: {
          dashboard: "Dashboard",
          connections: "Conexiones",
          chatsTempoReal: "Panel de Asistencia",
          tickets: "Inbox",
          quickMessages: "Respuestas Rápidas",
          contacts: "Contactos",
          wallets: "Billeteras",
          queues: "Filas",
          tags: "Tags",
          administration: "Administración",
          companies: "Empresas",
          users: "Usuarios",
          settings: "Configuración",
          ratings: "Regist. Evaluaciones",
          helps: "Ayuda",
          messagesAPI: "API",
          schedules: "Programa",
          campaigns: "Campañas",
          annoucements: "Informativos",
          chats: "Chat Interno",
          chatInternal: "Chat Interno",
          financeiro: "Financiero",
          queueIntegration: "Integraciones",
          version: "Versión",
          kanban: "Kanban",
          prompts: "Talk.Ai",
          allConnections: "Admin conexiones",
          automations: "Automatizaciones",
        },
        appBar: {
          user: {
            profile: "Perfil",
            logout: "Cerrar Sesión",
            message: "Hola",
            messageEnd: "bienvenido a",
            active: "Activo hasta",
            goodMorning: "Hola,",
            myName: "mi nombre es",
            continuity: "y te seguiré apoyando.",
            virtualAssistant: "Asistente Virtual",
            token:
              "Token inválido, favor comunicarse con el administrador de la plataforma.",
          },
          message: {
            location: "Localización",
            contact: "Contacto",
          },
          notRegister: "No hay registros",
          refresh: "Actualizar",
          tooltips: {
            menu: "Abrir menú",
            language: "Cambiar idioma",
            toggleTheme: "Alternar tema claro/oscuro",
            volume: "Configuración de volumen",
            refresh: "Actualizar página",
            notifications: "Notificaciones",
            announcements: "Informativos",
            chat: "Chat interno",
            userMenu: "Menú de usuario",
          },
        },
      },
      languages: {
        undefined: "Idioma",
        "es-Mx": "Español",
        es: "Español",
        en: "English",
        tr: "Türkçe",
      },
      messagesAPI: {
        title: "API",
        toSend: "ENVIAR",
        textMessage: {
          number: "Número",
          body: "Mensaje",
          token: "Token registrado",
          userId: "ID usuario/agente",
          queueId: "ID Fila",
        },
        mediaMessage: {
          number: "Número",
          body: "Nombre del archivo",
          media: "Archivo",
          token: "Token registrado",
        },
        API: {
          title: "Documentación para envío de mensajes",
          methods: {
            title: "Métodos de Envío",
            messagesText: "Mensajes de Texto",
            messagesMidia: "Mensajes de Midia",
          },
          instructions: {
            title: "Instrucciones",
            comments: "Observaciones Importantes",
            comments1:
              "Antes de enviar mensajes, es necesario registrar el token vinculado a la conexión que enviará los mensajes. <br />Para registrarse, acceda al menú 'Conexiones', haga clic en el botón de edición de la conexión e inserte el token en el campo correspondiente.",
            comments2:
              "El número de envío no debe tener máscara ni caracteres especiales y debe constar de:",
            codeCountry: "Código del País",
            code: "Código del Estado",
            number: "Numero",
          },
          text: {
            title: "1. Mensajes de Texto",
            instructions:
              "A continuación se muestra la lista de información necesaria para enviar mensajes de texto:",
          },
          media: {
            title: "2. Mensagens de Media",
            instructions:
              "A continuación se muestra la lista de información necesaria para enviar mensajes con archivos:",
          },
        },
      },
      notifications: {
        noTickets: "Sin notificaciones.",
      },
      quickMessages: {
        title: "Respuestas Rápidas",
        searchPlaceholder: "Buscar...",
        noAttachment: "No hay",
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Esta acción no se puede revertir. ¿Continuar?",
        },
        buttons: {
          add: "Agregar",
          attach: "Adjuntar Archivo",
          cancel: "Cancelar",
          edit: "Editar",
        },
        toasts: {
          success: "Atajo agregado satisfactoriamente.",
          deleted: "Atajo excluido satisfactoriamente.",
        },
        dialog: {
          title: "Mensaje Rápida",
          shortcode: "Atajo",
          message: "Respuesta",
          save: "Guardar",
          cancel: "Cancelar",
          general: "General",
          geral: "Global",
          add: "Agregar",
          edit: "Editar",
          visao: "Permitir visión",
        },
        table: {
          shortcode: "Atajo",
          message: "Mensaje",
          actions: "Acciones",
          mediaName: "Nombre del Archivo",
          status: "Status",
        },
      },
      contactLists: {
        title: "Listado de Contactos",
        table: {
          name: "Nombre",
          contacts: "Contactos",
          actions: "Acciones",
        },
        buttons: {
          add: "Nuevo Listado",
        },
        dialog: {
          name: "Nombre",
          company: "Empresa",
          okEdit: "Editar",
          okAdd: "Agregar",
          add: "Agregar",
          edit: "Editar",
          cancel: "Cancelar",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Esta acción no se puede revertir.",
        },
        toasts: {
          deleted: "Registro excluído",
          saved: "Lista guardada con éxito.",
        },
      },
      contactListItems: {
        title: "Contactos",
        searchPlaceholder: "Búsqueda",
        buttons: {
          add: "Nuevo",
          lists: "Listados",
          import: "Importar",
        },
        dialog: {
          name: "Nombre",
          number: "Número",
          whatsapp: "Whatsapp",
          email: "Correo electrónico",
          okEdit: "Editar",
          okAdd: "Agregar",
          add: "Agregar",
          edit: "Editar",
          cancel: "Cancelar",
        },
        table: {
          name: "Nombre",
          number: "Número",
          whatsapp: "Whatsapp",
          email: "Correo electrónico",
          actions: "Acciones",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Esta acción no se puede revertir.",
          importMessage: "¿Quieres importar esta plantilla? ",
          importTitlte: "Importar",
        },
        toasts: {
          deleted: "Registro excluído",
        },
      },
      kanban: {
        title: "Kanban",
        searchPlaceholder: "Búsqueda",
        subMenus: {
          list: "Admin",
          tags: "Lanes",
        },
      },
      campaigns: {
        title: "Campañas",
        searchPlaceholder: "Búsqueda",
        subMenus: {
          list: "Listados",
          listContacts: "Listados de contatos",
          settings: "Configuraciones",
        },
        settings: {
          randomInterval: "Intervalo de disparo aleatorio",
          noBreak: "Sin Intervalo",
          intervalGapAfter: "Intervalo mayor después de",
          undefined: "No definido",
          messages: "mensajes",
          laggerTriggerRange: "Intervalo de envío más grande",
          addVar: "Agregar variable",
          save: "Guardar",
          close: "Cerrar",
          add: "Agregar",
          shortcut: "Atajo",
          content: "Contenido",
        },
        buttons: {
          add: "Nueva Campaña",
          contactLists: "Listado de Contactos",
        },
        table: {
          name: "Nombre",
          whatsapp: "Conexión",
          contactList: "Listado de Contactos",
          option: "Ninguna",
          disabled: "Activada",
          enabled: "Desactivada",
          status: "Status",
          scheduledAt: "Programa",
          completedAt: "Finalizada",
          confirmation: "Confirmación",
          actions: "Acciones",
        },
        dialog: {
          new: "Nueva Campaña",
          update: "Editar Campaña",
          readonly: "Solo Visualizar",
          help: "Use variables como {nombre}, {numero}, {email} o defina variables personalizadas.",
          form: {
            name: "Nombre",
            message1: "Mensaje 1",
            message2: "Mensaje 2",
            message3: "Mensaje 3",
            message4: "Mensaje 4",
            message5: "Mensaje 5",
            confirmationMessage1: "Mensaje de Confirmación 1",
            confirmationMessage2: "Mensaje de Confirmación 2",
            confirmationMessage3: "Mensaje de Confirmación 3",
            confirmationMessage4: "Mensaje de Confirmación 4",
            confirmationMessage5: "Mensaje de Confirmación 5",
            messagePlaceholder: "Contenido del Mensaje",
            whatsapp: "Conexión",
            status: "Status",
            scheduledAt: "Programa",
            confirmation: "Confirmación",
            contactList: "Listado de Contacto",
            tagList: "Tags",
            statusTicket: "Status del Ticket",
            openTicketStatus: "Abierto",
            closedTicketStatus: "Cerrado",
            enabledOpenTicket: "Activado",
            disabledOpenTicket: "Desactivado",
            openTicket: "Abrir ticket",
          },
          buttons: {
            add: "Agregar",
            edit: "Actualizar",
            okadd: "Ok",
            cancel: "Cancelar Envíos",
            restart: "Reiniciar Envíos",
            close: "Cerrar",
            attach: "Anexar Archivo",
          },
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Esta acción no se puede revertir.",
        },
        toasts: {
          success: "Acción realizada satisfactoriamente",
          pause: "Campaña pausada",
          cancel: "Campaña cancelada",
          restart: "Campaña reiniciada",
          deleted: "Registro excluido",
        },
      },
      campaignReport: {
        title: "Reporte de",
        inactive: "Inactiva",
        scheduled: "Programada",
        process: "En Proceso",
        suspendedConnection: "Suspendida por conexión",
        cancelled: "Cancelada",
        finished: "Finalizada",
        campaign: "Campaña",
        validContacts: "Contactos Válidos",
        confirmationsRequested: "Confirmaciones Solicitadas",
        confirmations: "Confirmaciones",
        deliver: "Entregadas",
        connection: "Conexión",
        contactLists: "Listado de Contactos",
        schedule: "Programados",
        conclusion: "Conclusión",
      },
      announcements: {
        title: "Boletines",
        searchPlaceholder: "Búsqueda",
        active: "Activo",
        inactive: "Inactivo",
        buttons: {
          add: "Nuevo Boletin",
          contactLists: "Listados de Boletines",
        },
        table: {
          priority: "Prioridad",
          title: "Título",
          text: "Texto",
          mediaName: "Archivo",
          status: "Status",
          actions: "Acciones",
        },
        dialog: {
          edit: "Editar Boletin",
          add: "Nuevo Boletin",
          update: "Editar Boletin",
          readonly: "Solo visualizar",
          form: {
            priority: "Prioridad",
            title: "Título",
            text: "Texto",
            mediaPath: "Archivo",
            status: "Status",
            high: "Alta",
            medium: "Mediana",
            low: "Baja",
            active: "Activo",
            inactive: "Inactivo",
          },
          buttons: {
            add: "Agregar",
            edit: "Actualizar",
            okadd: "Ok",
            cancel: "Cancelar",
            close: "Cerrar",
            attach: "Anexar Archivo",
          },
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Esta acción no se puede revertir.",
        },
        toasts: {
          success: "Acción realizada satisfactoriamente",
          deleted: "Registro excluido",
        },
      },
      campaignsConfig: {
        title: "Configuraciones de Campañas",
      },
      queues: {
        title: "Filas",
        table: {
          name: "Nombre",
          color: "Color",
          greeting: "Mensaje de saludo",
          orderQueue: "Orden de la fila (bot)",
          actions: "Acciones",
          ID: "ID",
        },
        buttons: {
          add: "Agregar fila",
        },
        toasts: {
          success: "Fila guardada",
          deleted: "Fila excluida",
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage:
            "¿Estás seguro? ¡Esta acción no se puede revertir! Los tickets en esa fila seguirán existiendo, pero ya no tendrán ninguna fila asignada.",
        },
      },
      queue: {
        queueData: "Datos",
      },
      queueSelect: {
        inputLabel: "Filas",
        inputLabelRO: "Filas solo para lectura",
        withoutQueue: "Sin cola",
      },
      queueIntegration: {
        title: "Integraciones",
        table: {
          id: "ID",
          type: "Tipo",
          name: "Nombre",
          projectName: "Nombre del Proyecto",
          language: "Idioma",
          lastUpdate: "Ultima actualización",
          actions: "Acciones",
        },
        buttons: {
          add: "Agregar Proyecto",
        },
        searchPlaceholder: "Buscar...",
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage:
            "¿Estás seguro? ¡Esta acción no se puede revertir! Se eliminarán las filas y conexiones enlazadas",
        },
      },
      users: {
        title: "Usuarios",
        table: {
          status: "Status",
          name: "Nombre",
          email: "Correo Electrónico",
          profile: "Perfil",
          startWork: "Inicio del trabajo",
          endWork: "Final de trabajo",
          actions: "Acciones",
          ID: "ID",
        },
        buttons: {
          add: "Agregar usuario",
        },
        toasts: {
          deleted: "Usuario borrado satisfactoriamente.",
        },
        confirmationModal: {
          deleteTitle: "Borrar",
          deleteMessage:
            "Toda la información del usuario se perderá. Los tickets abiertos de los usuarios se moverán a la fila.",
        },
      },
      compaies: {
        title: "Empresas",
        table: {
          ID: "ID",
          status: "Activo",
          name: "Nombre",
          email: "Correo",
          password: "Contraseña",
          phone: "Teléfono",
          plan: "Plan",
          active: "Activo",
          numberAttendants: "Agentes",
          numberConections: "Conexiones",
          value: "Valor",
          namePlan: "Nombre del Plan",
          numberQueues: "Filas",
          useCampaigns: "Campañas",
          useExternalApi: "Rest API",
          useFacebook: "Facebook",
          useInstagram: "Instagram",
          useWhatsapp: "Whatsapp",
          useInternalChat: "Chat Interno",
          useSchedules: "Programa",
          createdAt: "F.Creación",
          dueDate: "Caducidad",
          lastLogin: "Ult. Login",
          folderSize: " Tamaño de carpeta ",
          totalFiles: "  Archivos totales",
          lastUpdate: "Última actualización",
          actions: "Acciones",
          money: "MXN",
          yes: "Si",
          no: "No",
          document: "CURP/RFC",
          recurrence: "Recurencia",
          monthly: "Mensual",
          bimonthly: "Bimestral",
          quarterly: "Trimestral",
          semester: "Semestral",
          yearly: "Anual",
          clear: "Limpiar",
          delete: "Eliminar",
          user: "Usuario",
          save: "Guardar",
        },
        buttons: {
          add: "Agregar empresa",
        },
        toasts: {
          deleted: "Empresa excluida satisfactoriamente.",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage:
            "Todas las informaciones de la empresa serán eliminadas. Los tickets abiertos de este usuário serán movidos a la fila.",
        },
      },
      plans: {
        form: {
          name: "Nombre",
          users: "Usuarios",
          connections: "Conexiones",
          campaigns: "Campañas",
          schedules: "Programas",
          enabled: "Activada",
          disabled: "Desactivada",
          clear: "Limpiar",
          delete: "Eliminar",
          save: "Guardar",
          yes: "Si",
          no: "No",
          money: "MXN",
          public: "Público",
          trial: "Prueba",
          trialDays: "Días de Prueba",
          billingCycle: {
            monthly: "mes",
            quarterly: "trimestre",
            semiannual: "semestre",
            annual: "año",
            custom: "personalizado",
          },
        },
      },
      helps: {
        title: "Ayuda",
        settings: {
          codeVideo: "Código del Video",
          description: "Descripción",
          clear: "Limpiar",
          delete: "Eliminar",
          save: "Guardar",
        },
      },
      schedules: {
        title: "Programas",
        date: "Fecha",
        time: "Hora",
        event: "Evento",
        allDay: "Todo el Día",
        week: "Semana",
        work_week: "Programaciones",
        day: "Día",
        month: "Mes",
        previous: "Anterior",
        next: "Siguiente",
        yesterday: "Ayer",
        tomorrow: "Mañana",
        today: "Hoy",
        agenda: "Agenda",
        noEventsInRange: "No hay eventos en este período.",
        confirmationModal: {
          deleteTitle: "¿Seguro que quieres excluir este Programa?",
          deleteMessage: "Esta acción no se puede revertir.",
        },
        table: {
          contact: "Contacto",
          body: "Mensaje",
          sendAt: "Fecha del Programa",
          sentAt: "Fecha de Envío",
          status: "Status",
          actions: "Acciones",
        },
        buttons: {
          add: "Nuevo Programa",
        },
        toasts: {
          deleted: "Programa eliminado satisfactoriamente.",
        },
      },
      tags: {
        title: "Tags",
        addColumns: "+ AGREGAR COLUMMAS",
        search: "BUSCAR",
        seeTicket: "VER BILLETE",
        confirmationModal: {
          deleteTitle: "¿Seguro que quieres excluir esta Tag?",
          deleteMessage: "Esta acción no se puede revertir.",
        },
        table: {
          name: "Nombre",
          kanban: "Kanban",
          color: "Color",
          tickets: "Registros Tags",
          contacts: "Contactos",
          actions: "Acciones",
        },
        buttons: {
          add: "Nueva Tag",
        },
        toasts: {
          deleted: "Tag eliminada satisfactoriamente.",
        },
      },
      tagsKanban: {
        title: "Lanes",
        laneDefault: "Abierto(s)",
        backToKanban: "VOLVER A KANBAN",
        confirmationModal: {
          deleteTitle: "¿Seguro que quieres excluir esta Lane?",
          deleteMessage: "Esta acción no se puede revertir.",
        },
        table: {
          name: "Nombre",
          color: "Color",
          tickets: "Tickets",
          actions: "Acciones",
        },
        buttons: {
          add: "Nueva Lane",
        },
        toasts: {
          deleted: "Lane eliminada satisfactoriamente.",
        },
      },
      files: {
        title: "Listado de archivos",
        table: {
          name: "Nombre",
          contacts: "Contactos",
          actions: "Acción",
        },
        toasts: {
          deleted: "Listado borrado satisfactoriamente!",
          deletedAll: "Todos los listados fueron borrados satisfactoriamente!",
        },
        buttons: {
          add: "Agregar",
          deleteAll: "Borrar Todos",
        },
        confirmationModal: {
          deleteTitle: "Borrar",
          deleteAllTitle: "Borrar Todos",
          deleteMessage: "Estás seguro de borrar este listado?",
          deleteAllMessage: "Estás seguro de borrar todos los listado?",
        },
      },
      settings: {
        success: "Configuración guardada satisfactoriamente.",
        title: "Configuración",
        tabs: {
          options: "Opciones",
          schedules: "Horarios",
          finalization: "Finalización del Atendimiento",
          plans: "Planes",
          helps: "Ayuda",
          companies: "Empresas",
          whitelabel: "Whitelabel",
          homepage: "Personalización Home",
          masks: "Máscaras",
          about: "Acerca de",
        },
        settings: {
          userCreation: {
            name: "Creación de usuarios",
            options: {
              enabled: "Habilitado",
              disabled: "Deshabilitado",
            },
          },
          tabs: {
            options: "Opciones",
            schedules: "Horarios",
            plans: "Planes",
            help: "Ayuda",
          },
          sections: {
            general: "Configuraciones Generales",
            generalDescription: "Configure las opciones principales del sistema",
            messages: "Mensajes",
            messagesDescription: "Personalice los mensajes enviados automáticamente",
            lgpd: "LGPD",
            lgpdDescription: "Configuraciones de privacidad y protección de datos",
            payments: "Pagos",
            paymentsDescription: "Configure métodos de pago",
            transcription: "Transcripción",
            transcriptionDescription: "Configuraciones de transcripción de audio",
            copyContact: "Configuración de Sigla para Copia de Contactos",
            copyContactDescription: "Configure cómo se formatean los números de teléfono al copiar contactos",
          },
          options: {
            disabled: "Deshabilitado",
            enabled: "Habilitado",
            updating: "Actualizando...",
            creationCompanyUser: "Creación de Empresa/Usuario",
            evaluations: "Evaluaciones",
            officeScheduling: "Programación de Horario",
            queueManagement: "Gestión por Cola",
            companyManagement: "Gestión por Empresa",
            connectionManagement: "Gestión por Conexión",
            sendGreetingAccepted: "Enviar saludo al aceptar el ticket",
            sendMsgTransfTicket:
              "Enviar mensaje de transferencia de sector/agente",
            checkMsgIsGroup: "Ignorar mensajes de grupos",
            chatBotType: "Tipo de Bot",
            userRandom: "Elegir agente aleatorio",
            buttons: "Botones",
            acceptCallWhatsapp:
              "¿Informar que no se aceptan llamadas por WhatsApp?",
            sendSignMessage: "Permitir al agente elegir ENVIAR firma",
            sendGreetingMessageOneQueues:
              "Enviar saludo cuando haya solo una cola",
            sendQueuePosition: "Enviar mensaje con la posición en la fila",
            sendFarewellWaitingTicket:
              "Enviar mensaje de despedida al estar en espera",
            acceptAudioMessageContact:
              "¿Aceptar audios de todos los contactos?",
            enableLGPD: "Habilitar tratamiento de datos (LGPD)",
            requiredTag: "Etiqueta obligatoria para cerrar el ticket",
            closeTicketOnTransfer: "Cerrar ticket al transferir a otra cola",
            DirectTicketsToWallets:
              "Mover automáticamente al cliente a la cartera",
            showNotificationPending:
              "Mostrar notificación para tickets pendientes",
            maskHint: "Escriba '@' para insertar máscaras dinámicas"
          },
          customMessages: {
            sendQueuePositionMessage: "Mensaje de posición en la fila",
            AcceptCallWhatsappMessage:
              "Mensaje para informar que no se aceptan llamadas",
            greetingAcceptedMessage: "Mensaje de saludo al aceptar el ticket",
            transferMessage:
              "Mensaje de transferencia - ${queue.name} = cola de destino",
          },
          LGPD: {
            title: "Politica de Privacidad",
            welcome: "Mensaje de bienvenida (PP)",
            linkLGPD: "Link de la política de privacidad",
            obfuscateMessageDelete: "Ofuscar mensaje borrada",
            alwaysConsent: "Requerir siempre el consentimiento",
            obfuscatePhoneUser: "Ofuscar número de telefono para usuarios",
            enabled: "Activado",
            disabled: "Desactivado",
          },
          masks: {
            title: "Guía de Referencia de Máscaras",
            description: "Use máscaras dinámicas para personalizar sus mensajes. Escriba '@' en los campos de mensaje para ver las opciones disponibles.",
            mask: "Máscara",
            description: "Descripción",
            example: "Ejemplo",
            howToUse: "Cómo usar:",
            usageInstructions: "1. Al editar un mensaje, escriba '@' para abrir el menú de máscaras\n2. Escriba parte del nombre de la máscara o descripción para filtrar\n3. Haga clic en la máscara deseada o presione Enter para seleccionar\n4. La máscara se insertará automáticamente en el texto\n\nEjemplo de mensaje completo:\n\"¡Hola ${contact.name}! Has sido transferido a la cola ${queue.name} y serás atendido por ${user.name}.\""
          },
        },
      },
      messagesList: {
        header: {
          assignedTo: "Asignado a:",
          dialogRatingTitle:
            "¿Quieres dejar un mensaje de evaluación para el cliente?",
          dialogClosingTitle: "Finalizando la atención al cliente!",
          dialogRatingCancel: "Cerrar CON Mensaje de Despedida",
          dialogRatingSuccess: "Cerrar y Enviar Evaluación",
          dialogRatingWithoutFarewellMsg: "Cerrar SIN Mensaje de Despedida",
          ratingTitle: "Elegir menú de evaluación",
          notMessage: "No hay mensaje seleccionado",
          buttons: {
            return: "Devolver",
            resolve: "Resolver",
            reopen: "Reabrir",
            accept: "Aceptar",
            rating: "Enviar Evaluación",
            enableIntegration: "Activar/Desactivar integración",
            logTicket: "Logs del Ticket",
            requiredTag:
              "Opps! Debes asignar una tag antes de cerrar el ticket.",
          },
        },
      },
      messagesInput: {
        cancelForward: "Cancelar",
        placeholderPrivateMessage:
          "Entre como un mensaje o con / para respuestas rápidas",
        placeholderOpen:
          "Entre como un mensaje o con / para respuestas rápidas",
        placeholderClosed:
          "Vuelva a abrir o acepte este ticket para enviar un mensaje.",
        signMessage: "Firmar",
        privateMessage: "Mensaje Privada",
      },
      contactDrawer: {
        header: "Detalles del contacto",
        buttons: {
          edit: "Editar contacto",
          block: "Bloquear",
          unblock: "Desbloquear",
        },
        extraInfo: "Otras informaciones",
      },
      messageVariablesPicker: {
        label: "Variables disponibles",
        vars: {
          contactFirstName: "Primer Nombre",
          contactName: "Nombre",
          user: "Agente",
          greeting: "Saludos",
          protocolNumber: "Protocolo",
          date: "Fecha",
          hour: "Hora",
          ticket_id: "Nº del Ticket",
          queue: "Sector",
          connection: "Conexión",
        },
      },
      ticketOptionsMenu: {
        schedule: "Programa",
        delete: "Borrar",
        transfer: "Transferir",
        registerAppointment: "Observaciones del Contacto",
        resolveWithNoFarewell: "Cerrar sin despedida",
        acceptAudioMessage: "¿Aceptar audios del contacto?",
        appointmentsModal: {
          title: "Observaciones del Contacto",
          textarea: "Observación",
          placeholder: "Agregue aqui la información",
        },
        confirmationModal: {
          title: "¿Borrar ticket #",
          titleFrom: "del contacto ",
          message:
            "¡Atención! Todos los mensajes Todos los mensajes relacionados con el ticket se perderán.",
        },
        buttons: {
          delete: "Borrar",
          cancel: "Cancelar",
        },
      },
      confirmationModal: {
        buttons: {
          confirm: "Ok",
          cancel: "Cancelar",
        },
      },
      messageInput: {
        tooltip: {
          signature: "Activar/Desactivar firma",
          privateMessage: "Activar/Desactivar mensaje privado",
          meet: "Enviar link para videollamada",
        },
        type: {
          imageVideo: "Fotos y videos",
          cam: "Cámara",
          contact: "Contacto",
          meet: "Link Jitsi Meet",
        },
      },
      messageOptionsMenu: {
        delete: "Borrar",
        reply: "Responder",
        edit: "Editar",
        forward: "Enviar",
        toForward: "Enviar",
        talkTo: "Platicar Con",
        copy: "Copiar",
        react: "Reaccionar",
        favorite: "Favorito",
        confirmationModal: {
          title: "¿Borrar mensaje?",
          message: "Esta acción no puede ser revertida.",
        },
      },
      invoices: {
        table: {
          invoices: "Facturas",
          details: "Detalles",
          users: "Usuarios",
          connections: "Conexiones",
          queue: "Filas",
          value: "Valor",
          expirationDate: "Fecha Venc.",
          action: "Acción",
        },
      },
      backendErrors: {
        ERR_NO_OTHER_WHATSAPP:
          "Debe haber al menos una conexión de WhatsApp predeterminada.",
        ERR_NO_DEF_WAPP_FOUND:
          "No se encontró WhatsApp predeterminado. Verifique la página de conexiones.",
        ERR_WAPP_NOT_INITIALIZED:
          "Esta sesión de WhatsApp no ​​está inicializada. Verifique la página de conexiones.",
        ERR_WAPP_CHECK_CONTACT:
          "No se pudo verificar el contacto de WhatsApp. Verifique la página de conexiones.",
        ERR_WAPP_INVALID_CONTACT: "Este no es un número de whatsapp válido.",
        ERR_WAPP_DOWNLOAD_MEDIA:
          "No se pudieron descargar los medios de WhatsApp. Verifique la página de conexiones.",
        ERR_INVALID_CREDENTIALS: "Error de autenticación. Vuelva a intentarlo.",
        ERR_SENDING_WAPP_MSG:
          "Error al enviar el mensaje de WhatsApp. Verifique la página de conexiones.",
        ERR_SENDING_WAPP_REACTION:
          "Error al enviar la reacción de WhatsApp. Verifique la página de conexiones.",
        ERR_DELETE_WAPP_MSG: "No se pudo borrar el mensaje de WhatsApp.",
        ERR_MESSAGE_NOT_FOUND: "Mensaje no encontrado.",
        ERR_INVALID_MESSAGE_DATA: "Error al procesar los datos del mensaje.",
        ERR_MESSAGE_KEY_NOT_FOUND: "Clave del mensaje no encontrada.",
        ERR_CONTACT_NOT_FOUND: "Contacto no encontrado.",
        ERR_TICKET_NOT_FOUND: "Ticket no encontrado.",
        ERR_EMOJI_REQUIRED: "El emoji es obligatorio.",
        ERR_REACTIONS_ONLY_WHATSAPP: "Las reacciones solo están disponibles para WhatsApp.",
        ERR_OTHER_OPEN_TICKET: "Ya hay un ticket abierto para este contacto.",
        ERR_SESSION_EXPIRED: "Sesión caducada. Inicie sesión.",
        ERR_USER_CREATION_DISABLED:
          "La creación de usuarios fue deshabilitada por el administrador.",
        ERR_NO_PERMISSION: "No tienes permiso para acceder a este recurso.",
        ERR_DUPLICATED_CONTACT: "Ya existe un contacto con este número.",
        ERR_NO_SETTING_FOUND:
          "No se encontró ninguna configuración con este ID.",
        ERR_NO_CONTACT_FOUND: "No se encontró ningún contacto con este ID.",
        ERR_NO_TICKET_FOUND: "No se encontró ningún ticket con este ID.",
        ERR_NO_USER_FOUND: "No se encontró ningún usuario con este ID.",
        ERR_NO_WAPP_FOUND: "No se encontró WhatsApp con este ID.",
        ERR_CREATING_MESSAGE: "Error al crear el mensaje en la base de datos.",
        ERR_CREATING_TICKET: "Error al crear el ticket en la base de datos.",
        ERR_FETCH_WAPP_MSG:
          "Error al obtener el mensaje en WhtasApp, tal vez sea demasiado antiguo.",
        ERR_QUEUE_COLOR_ALREADY_EXISTS:
          "Este color ya está en uso, elija otro.",
        ERR_WAPP_GREETING_REQUIRED:
          "El mensaje de saludo es obligatorio cuando hay más de una fila.",
        ERR_OUT_OF_HOURS: "¡Fuera del horario de oficina!",
      },
      messagesAPIInstructions: {
        endpoint: "Endpoint:",
        method: "Método:",
        post: "POST",
        headers: "Headers:",
        headerAuthorization:
          "Authorization Bearer (token registrado) y Content-Type (application/json)",
        body: "Body:",
        fieldNumber: '"number": "558599999999"',
        fieldBody: '"body": "Mensaje"',
        fieldUserId: '"userId": ID de usuario o ""',
        fieldQueueId: '"queueId": ID de la Cola o ""',
        fieldSendSignature: '"sendSignature": Firmar mensaje - true/false',
        fieldCloseTicket: '"closeTicket": Cerrar el ticket - true/false',
        singMessage: "Firmar mensaje - true/false",
        closeTicket: "Cerrar el ticket - true/false",
        testSend: "la test del envio",
      },
      recurrenceSection: {
        title: "Recurrence",
        description:
          "You can choose to send the message recurrently and select the interval. If it is a one-time message, do not change anything in this section.",
        labelInterval: "Interval",
        intervalFilterValue: "Valor del filtro de intervalo",
        sendAsManyTimes: " Enviar tantas veces",
        shipNormallyOnNonbusinessDays: "Envío normal en días no laborables",
        sendOneBusinessDayBefore: "Enviar un día hábil antes",
        sendOneBusinessDayLater: "Enviar un día hábil después",
        options: {
          days: "Days",
          weeks: "Weeks",
          months: "Months",
          minutes: "Minutes",
        },
      },
      servicePanel: {
        allowRealTime: "Panel de servicio",
      },
      financial: {
        invoices: "Facturas",
        details: "Detalles",
        users: "Usuarios",
        connections: "Conexiones",
        queues: "Colas",
        value: "Valor",
        expirationDate: "Fecha de Vencimiento",
        status: "Estado",
        action: "Acción",
      },
      statusFilter: {
        statusFilter: "Filtrar por estado",
      },
      momentsUser: {
        services: "Servicios:",
        pending: "Pendiente",
        noqueue: "SIN COLA",
      },
      campaignsPhrase: {
        campaignsFlow: "Flujo de Campaña",
        campaigns: "Campaña",
        name: "Nombre",
        status: "Estado",
        newCampaignWithFlowByPhrase: "Nueva campaña con flujo por frase",
        editCampaignWithFlowByPhrase: "Editar campaña con flujo por frase",
        phraseTriggerName: "Nombre del disparador de frase",
        chooseAStream: "Elige una transmisión",
        whichPhraseTriggersTheFlow: " ¿Qué frase desencadena el flujo?",
        selectAConnection: "Seleccione una conexión",
        status: " Estado",
        cancel: "CANCELAR",
        createCampaign: "CREAR CAMPAÑA ",
        saveCampaign: "Guardar Campaña",
      },
      whatsappModalRel: {
        form: {
          isOficial: "Informe de Soporte",
          ticketId: "ID del Ticket",
          client: "Cliente",
          number: "Número",
          agent: "Agente",
          date: "Fecha",
          lastMessage: "Último Mensaje",
          fullReport: "El informe completo está adjunto arriba",
          resolveAndTriggerIntegration: "Resolver y Disparar Integración",
          elementNotFoundForExport: "Elemento no encontrado para exportar.",
          reportFilename: "informe_soporte",
        },
      },
      chatList: {
        noMessages: "Sin mensajes",
        admin: "Administrador",
        member: "Miembro",
        searchChat: "Buscar chat...",
        createNewChat: "Crear nuevo chat",
        searchUser: "Buscar usuario...",
        noUserFound: "No se encontró usuario",
        noUserAvailable: "No hay usuarios disponibles",
        cancel: "Cancelar",
        details: "Detalles",
        deleteChat: "Eliminar Chat",
        deleteChatConfirm: "Esta acción no se puede deshacer, ¿confirmar?",
        detailsTitle: "Detalles",
        edit: "Editar",
        delete: "Eliminar",
        now: "ahora",
        minutesAgo: "hace {{count}}m",
        hoursAgo: "hace {{count}}h",
      },
      chatMessages: {
        deleted: "Este mensaje fue eliminado",
        deletedAdmin: "Mensaje eliminado - visible solo para administradores",
        reply: "Responder",
        edit: "Editar",
        delete: "Eliminar",
        forward: "Reenviar",
        editMessage: "Editar Mensaje",
        save: "Guardar",
        cancel: "Cancelar",
        deleteMessage: "Eliminar Mensaje",
        deleteMessageConfirm:
          "¿Está seguro de que desea eliminar este mensaje?",
        forwardMessage: "Reenviar Mensaje",
        selectChat: "Seleccione el chat",
        doubleClickToReply: "Doble clic para responder",
        edited: "(editado)",
        forwarded: "(reenviado)",
        typeMessage: "Escribe un mensaje...",
        send: "Enviar",
        noMessages: "Sin mensajes",
        loading: "Cargando...",
        replyingTo: "Respondiendo a",
        clickToGoToOriginal: "Haga clic para ir al mensaje original",
      },
      chatPopover: {
        reply: "Responder",
        edit: "Editar",
        delete: "Eliminar",
        forward: "Reenviar",
        cancel: "Cancelar",
        confirmDelete: "Confirmar Eliminación",
        confirm: "Confirmar",
        editMessage: "Editar Mensaje",
        save: "Guardar",
        forwardMessage: "Reenviar Mensaje",
        selectChat: "Seleccione el chat",
        noChats: "No hay chats disponibles",
      },
      chatIndex: {
        chats: "Chats",
        groups: "Grupos",
        new: "Nuevo",
        messages: "Mensajes",
        search: "Buscar...",
        noChats: "No se encontraron chats",
        noGroups: "No se encontraron grupos",
        noMessages: "Sin mensajes",
        loading: "Cargando...",
        error: "Error al cargar los datos",
        addGroupPhoto: "Agregar Foto de Grupo",
        changeGroupPhoto: "Cambiar Foto de Grupo",
        groupName: "Nombre del Grupo",
        groupDescription: "Descripción del Grupo",
        save: "Guardar",
        cancel: "Cancelar",
        createGroup: "Crear Grupo",
        editGroup: "Editar Grupo",
        deleteGroup: "Eliminar Grupo",
        deleteGroupConfirm: "¿Está seguro de que desea eliminar este grupo?",
        edit: "Editar",
        delete: "Eliminar",
        details: "Detalles",
        groupDetails: "Detalles del Grupo",
        title: "Título",
        description: "Descripción",
        modal: {
          title: "Crear Grupo",
          editTitle: "Editar Grupo",
          save: "Guardar",
          cancel: "Cancelar",
          description: "Ingrese el nombre y la descripción del grupo.",
          name: "Group Name",
          create: "Create",
          edit: "Editar",
        },
      },
      whitelabel: {
        primaryColorLight: "Color Primario (Tema Claro)",
        primaryColorDark: "Color Primario (Tema Oscuro)",
        secondaryColorLight: "Color Secundario (Tema Claro)",
        secondaryColorDark: "Color Secundario (Tema Oscuro)",
        useGradient: "Usar Degradado",
        useGradientDescription: "Activar efecto degradado en elementos visuales",
        appName: "Nombre de la Aplicación",
        logoLight: "Logo (Tema Claro)",
        logoDark: "Logo (Tema Oscuro)",
        favicon: "Favicon",
        backgroundLight: "Imagen de Fondo (Tema Claro)",
        backgroundDark: "Imagen de Fondo (Tema Oscuro)",
        preview: "Vista Previa",
        delete: "Eliminar",
        upload: "Subir",
        availableLanguages: "Idiomas Disponibles",
        atLeastOneLanguage: "Al menos un idioma debe estar habilitado",

        sections: {
          general: "Configuraciones Generales",
          generalDescription: "Configura el nombre y la información básica de la aplicación",
          colors: "Colores y Temas",
          colorsDescription: "Personaliza los colores primarios y secundarios para los temas claro y oscuro",
          logos: "Logos e Imágenes",
          logosDescription: "Sube los logos e imágenes de fondo de la aplicación",
          languages: "Idiomas Disponibles",
          languagesDescription: "Selecciona qué idiomas estarán disponibles en el sistema"
        }
      },
    },
  },
};

const extraTranslations = {
  common: {
    none: "Ninguna",
    yes: "Sí",
    no: "No",
    buttons: {
      save: "Guardar",
      cancel: "Cancelar",
      close: "Cerrar",
      edit: "Editar",
      delete: "Eliminar",
      create: "Crear",
      update: "Actualizar",
      saving: "Guardando...",
    },
    status: {
      active: "Activa",
      inactive: "Inactiva",
      enabled: "Habilitada",
      disabled: "Deshabilitada",
    },
    toasts: {
      operationSuccess: "¡Operación realizada con éxito!",
    },
  },
  ticketsAdvanced: {
    buttons: { selectTicket: "Seleccionar Ticket" },
    tabs: { ticket: "Ticket", attendances: "Atenciones" },
  },
  dashboard: {
    title: "Dashboard",
    filterLabels: {
      period: "Filtro de Período",
      days: "{{count}} días",
      dateRange: "Rango de Fechas",
      queues: "Colas",
      attendants: "Agentes",
      connections: "Conexiones",
      channels: "Canales",
    },
    sections: {
      performanceIndicators: "Indicadores de Rendimiento",
      satisfactionSurvey: "Encuesta de satisfacción",
      hourlyDistribution: "Distribución por horario",
      attendances: "Atenciones",
      attendants: "Agentes",
    },
    performance: {
      totalAttendances: "Total de atenciones",
      closed: "Cerradas",
      open: "Abiertas",
      pending: "Pendientes",
      withoutQueue: "Sin Cola Definida",
      withoutUser: "Sin Agente Definido",
      attendants: "Agentes",
      averageServiceTime: "Tiempo Medio de Atención",
      averageWaitingTime: "Tiempo Medio Hasta el Inicio",
      newContacts: "Nuevos Contactos",
      details: "Grupos: {{groups}} | Privados: {{private}}",
    },
  },
  chat: {
    toasts: {
      exists: "¡Ya existe un chat con este usuario!",
      saveError: "Error al crear/editar chat",
      loadUsersError: "Error al cargar usuarios",
      created: "¡Chat creado con éxito!",
      createError: "Error al crear chat",
    },
    groupPhoto: { change: "Cambiar Foto del Grupo", add: "Agregar Foto del Grupo" },
    form: { title: "Título", description: "Descripción", groupDescriptionPlaceholder: "Descripción del grupo" },
    alerts: { editWindowExpired: "Solo es posible editar mensajes enviados hace menos de 10 minutos." },
    modals: {
      editMessage: { title: "Editar Mensaje", message: "Mensaje" },
      forwardMessage: { title: "Reenviar Mensaje", selectChat: "Seleccione el chat", forward: "Reenviar" },
    },
  },
  contacts: {
    toasts: { blocked: "Contacto bloqueado", unblocked: "Contacto desbloqueado" },
    table: { photo: "Foto", status: "Estado" },
    bulk: {
      deleteAllWithCount: "Eliminar Todos ({{count}})",
      deleteSelectedWithCount: "Eliminar Seleccionados ({{count}})",
      delete: "Eliminar",
      selectedSummary: "{{count}} seleccionado(s)",
      selectedContactsSummary: "{{count}} contacto(s) seleccionado(s)",
      allShort: "(TODOS)",
      allContacts: "(TODOS LOS CONTACTOS)",
      deleteAllTooltip: "Eliminar todos los contactos",
      deleteSelectedTooltip: "Eliminar contactos seleccionados",
      deleteSelected: "Eliminar seleccionados",
      deleteAllContacts: "Eliminar Todos los Contactos",
      cancelSelection: "Cancelar selección",
      selectAllAria: "Seleccionar todos los contactos",
    },
    importProgress: {
      starting: "Iniciando importación...",
      startingImport: "Iniciando importación...",
      importing: "Importando contactos...",
      importError: "Error al importar contactos",
      error: "Error en la importación",
      completed: "¡Importación concluida!",
      processingGroups: "📁 Procesando Grupos",
      processingContacts: "👥 Procesando Contactos",
      processed: "Procesado",
      fetchingWhatsapp: "Buscando datos de WhatsApp...",
      groupsTitle: "📁 Grupos ({{count}})",
      contactsTitle: "👥 Contactos ({{count}})",
      created: "Creados",
      updated: "Actualizados",
      skipped: "Ignorados",
      whatsappWebNoSync: "WhatsApp Web no sincroniza automáticamente la lista de contactos.",
      contactsCreatedOnMessages: "Los contactos se crean cuando envías o recibes mensajes.",
      duration: "Tiempo de ejecución: {{seconds}}s",
    },
  },
  contactDrawer: {
    toasts: {
      checkTicketsError: "Error al verificar tickets existentes",
      startParticipantChatError: "No fue posible iniciar la conversación con este participante",
      noParticipantsToExport: "No hay participantes para exportar",
      exportSuccess: "¡Archivo \"{{fileName}}\" exportado con éxito!",
      exportError: "Error al exportar participantes",
      blocked: "Contacto bloqueado",
      unblocked: "Contacto desbloqueado",
      updated: "¡Contacto actualizado con éxito!",
    },
    empty: { images: "No se encontraron imágenes", videos: "No se encontraron videos", audios: "No se encontraron audios", documents: "No se encontraron documentos", links: "No se encontraron enlaces" },
    searchPlaceholder: "Buscar en los mensajes...",
    tabs: { info: "Información", images: "Imágenes", videos: "Videos", audios: "Audios", documents: "Documentos", links: "Enlaces", participants: "Participantes" },
    actions: { blockContact: "Bloquear contacto", unblockContact: "Desbloquear contacto", export: "Exportar", chat: "Conversar" },
    warning: { possibleLid: "⚠️ Posible error: el número parece ser LID" },
    participants: { title: "Participantes del Grupo ({{count}})" },
    roles: { superAdmin: "Super Admin", admin: "Admin" },
    fallbacks: { otherUser: "Otro usuario", noQueue: "Sin cola" },
  },
  messageInput: {
    tooltip: {
      signature: "Habilitar/Deshabilitar Firma",
      privateMessage: "Habilitar/Deshabilitar Mensaje Privado",
      triggerFlow: "Disparar Flujo",
      requiredTemplate: "Enviar Template Meta (Obligatorio)",
      pendingModeSwitch: "Alternar: mensaje normal / interno",
      ticketNote: "Observación del ticket",
    },
    type: { document: "Documento", signature: "Firma" },
    format: { bold: "Negrita", italic: "Cursiva", strikethrough: "Tachado", code: "Código", numberedList: "Lista Numerada", bulletList: "Lista con Viñetas", quote: "Cita", clear: "Limpiar Formato" },
    pendingAlert: { title: "Ticket Pendiente:", description: "Use mensaje normal para aceptar y responder, mensaje interno u observación para notas internas." },
    placeholder: { internalMessage: "Mensaje interno (no se envía al cliente)", ticketNote: "Observación del ticket (nota interna)" },
    quickAnswers: { keyboardHint: "📋 {{count}} respuestas • use ↑↓ para navegar", scrollHint: "{{count}} respuestas • desplácese para ver más" },
  },
  messagesList: {
    status: { forwarded: "Reenviada", editedAt: "Editada {{time}}" },
    deletedMessage: "🚫 Este mensaje fue eliminado",
    deletedMessageByContact: "🚫 Este mensaje fue eliminado por el contacto",
    deletedMessageMarkdown: "🚫 _Mensaje eliminado_ ",
    reactions: { contactReacted: "{{contact}} reaccionó... {{reaction}}", youReacted: "Reaccionaste... {{reaction}}" },
  },
  campaigns: {
    filters: { status: "Filtrar por Estado", recurrence: "Filtrar por Recurrencia", all: "Todos", allFemale: "Todas", recurring: "Recurrentes", single: "Únicas" },
    status: { inactive: "Inactiva", scheduled: "Programada", inProgress: "En Progreso", suspendedConnection: "Suspendida por conexión - reanudación manual", cancelled: "Cancelada", finished: "Finalizada" },
    operationalStatus: { paused: "Pausada", scheduled: "Programada", cancelled: "Cancelada", failed: "Falló", suspendedManual: "Suspendida - espera reanudación manual", completed: "Concluida", running: "En ejecución", pending: "Pendiente" },
    recurrence: { minutely: "Por Minuto", hourly: "Por Hora", daily: "Diaria", weekly: "Semanal", biweekly: "Quincenal", monthly: "Mensual", yearly: "Anual", executions: "{{count}} ejecuciones", single: "Única", finished: "Recurrencia finalizada" },
    table: { recurrence: "Recurrencia", nextExecution: "Próxima Ejecución" },
    toasts: { noPermissionRedirect: "¡Esta empresa no tiene permiso para acceder a esta página! Redirigiendo.", stopRecurrence: "¡Recurrencia interrumpida con éxito!" },
    confirmationModal: { stopRecurrenceTitle: "Interrumpir Recurrencia", stopRecurrenceMessage: "¿Está seguro de que desea interrumpir la recurrencia de esta campaña? La campaña actual seguirá ejecutándose, pero no habrá ejecuciones futuras." },
    tooltips: { recurringCampaign: "Campaña Recurrente", suspendedConnection: "La campaña quedó suspendida por caída/desconexión y no vuelve sola después de reconectar.", pauseCampaign: "Pausar Campaña", resumeCampaign: "Reanudar Campaña", resumeCampaignManually: "Reanudar Campaña Manualmente", stopRecurrence: "Interrumpir Recurrencia", report: "Informe" },
    fallbacks: { removedList: "Lista eliminada", notDefined: "No definida", removedWhatsapp: "WhatsApp eliminado", noSchedule: "Sin programación", notCompleted: "No concluida" },
    pagination: { total: "Total: {{count}} campañas", rowsPerPage: "Filas por página:", displayedRows: "{{from}}-{{to}} de {{count}}", moreThan: "más de {{to}}" },
    dialog: {
      form: { variablesHelper: "💡 Escriba @ para insertar variables dinámicas (ej: {{name}}, {{contactNumber}}, {{contactEmail}})" },
      validation: { tooShort: "¡Muy corto!", tooLong: "¡Muy largo!", required: "Obligatorio", connectionRequired: "La conexión es obligatoria", recurrenceTypeRequired: "El tipo de recurrencia es obligatorio", intervalGreaterThanZero: "El intervalo debe ser mayor que 0", intervalRequired: "El intervalo es obligatorio", weekDayRequired: "Seleccione al menos un día de la semana" },
      recurrence: { title: "Configuración de Recurrencia", enable: "Habilitar recurrencia", type: "Tipo de Recurrencia", interval: "Intervalo", intervalHelper: "Cada {{interval}} {{unit}}", weekDays: "Días de la Semana", dayOfMonth: "Día del Mes", dayOfMonthHelper: "Día específico del mes (1-31)", endDate: "Fecha Final (opcional)", maxExecutions: "Máximo de Ejecuciones (opcional)", infiniteHelper: "Deje vacío para recurrencia infinita", hideNextExecutions: "Ocultar Próximas Ejecuciones", showNextExecutions: "Ver Próximas Ejecuciones", nextFiveExecutions: "Próximas 5 Ejecuciones:", executionNumber: "{{count}}ª Ejecución", units: { minutes: "minuto(s)", hours: "hora(s)", days: "día(s)", weeks: "semana(s)", biweeks: "quincena(s)", months: "mes(es)", years: "año(s)" } },
      messageTab: "Msg. {{count}}",
    },
  },
  campaignsPhrase: {
    toasts: { loadFlowsError: "Error al cargar flujos", loadConnectionsError: "Error al cargar conexiones", loadCampaignError: "Error al cargar datos de la campaña", requiredFields: "Por favor, complete todos los campos obligatorios", flowNotFound: "Flujo seleccionado no encontrado", updated: "¡Campaña actualizada con éxito!", created: "¡Campaña creada con éxito!", saveError: "Error al guardar campaña" },
    form: { campaignName: "Nombre de la campaña", nameRequired: "El nombre es obligatorio", selectFlow: "Seleccione un flujo", flowRequired: "El flujo es obligatorio", multiple: "(Múltiples)", whatsappConnections: "Conexiones WhatsApp", connectionRequired: "Debe seleccionarse al menos una conexión", selectedConnections: "{{count}} conexión(es) seleccionada(s):", selectedConnectionsDescription: "La campaña se ejecutará cuando cualquiera de estas conexiones reciba mensajes que coincidan con las frases configuradas.", phrasesTitle: "Frases/Palabras que disparan el flujo", exactMatchTitle: "Coincidencia Exacta:", exactMatchDescription: "El mensaje debe ser idéntico a la frase configurada.", partialMatchTitle: "Coincidencia Parcial:", partialMatchDescription: "La frase puede estar contenida en cualquier parte del mensaje.", phraseLabel: "Frase {{count}}", phrasePlaceholder: "Escriba la frase o palabra clave", phraseRequired: "La frase es obligatoria", type: "Tipo", exact: "Exacta", partial: "Parcial", addPhrase: "Agregar Frase" },
  },
  flowBuilder: {
    title: "Flujos de Conversación ({{count}})",
    searchPlaceholder: "Buscar flujos...",
    toasts: { activated: "Flujo activado con éxito", deactivated: "Flujo desactivado con éxito", deleted: "Flujo eliminado con éxito", duplicated: "Flujo duplicado con éxito", selectZip: "Por favor, seleccione un archivo ZIP (.zip)", imported: "Flujo importado con éxito" },
    editor: { title: "Editor de Flujos", addNodes: "Agregar Nodos", saveFlow: "Guardar Flujo", toasts: { saved: "Flujo guardado con éxito", saveError: "Error al guardar el flujo" } },
  },
  floup: {
    title: "Follow UP - Templates de Flujo",
    stepsCount: "{{count}} pasos",
    buttons: { newTemplate: "Nuevo Template", duplicate: "Duplicar", saveTemplate: "Guardar Template", addStep: "Agregar Paso" },
    dialog: { editTitle: "Editar Template", newTitle: "Nuevo Template" },
    sections: { basicInfo: "Información Básica", triggerCondition: "Condición de Activación", stopControls: "Controles de Parada del Flujo", flowSteps: "Pasos del Flujo" },
    descriptions: { triggerCondition: "Defina cuándo debe activarse este Follow UP. Una vez activado, todos los pasos se ejecutarán secuencialmente hasta que se cumplan las condiciones de parada." },
    form: { templateName: "Nombre del Template", templateType: "Tipo de Template", description: "Descripción", condition: "Condición", selectQueue: "Seleccionar cola", selectTag: "Seleccionar tag", conditionDescription: "Descripción de la condición", conditionPlaceholder: "Ej: Cliente envió primer mensaje" },
    templateTypes: { client: "Cliente", lead: "Lead", custom: "Personalizado" },
    conditions: { queue: "Cola del sistema", tag: "Tag del sistema", firstClientInteraction: "Primera interacción del cliente", firstAttendantInteraction: "Primera interacción del agente" },
    delete: { title: "Confirmar Eliminación", message: "¿Está seguro de que desea eliminar el Follow UP", warning: "Esta acción no se puede deshacer y todos los medios asociados serán eliminados permanentemente." },
  },
  connections: { toasts: { loadError: "No fue posible cargar la lista de registros" } },
  settings: { toasts: { schedulesUpdated: "Horarios actualizados con éxito." } },
  companies: {
    form: { contactEmail: "Email de Contacto *", adminEmail: "Email del Administrador *", timezone: "Timezone", recurrence: "Recurrencia", generateInvoice: "Generar Factura" },
    toasts: { loadError: "No fue posible cargar la lista de registros", operationError: "No fue posible realizar la operación. Verifique si ya existe una empresa con el mismo nombre o si los campos fueron completados correctamente", deleteError: "No fue posible realizar la operación" },
    confirmation: { deleteTitle: "Eliminación de Registro", deleteMessage: "¿Realmente desea eliminar este registro?" },
  },
};

const mergeTranslations = (target, source) => {
  Object.keys(source).forEach((key) => {
    if (
      source[key] &&
      typeof source[key] === "object" &&
      !Array.isArray(source[key])
    ) {
      target[key] = target[key] || {};
      mergeTranslations(target[key], source[key]);
      return;
    }
    target[key] = source[key];
  });
};

mergeTranslations(messages.es.translations, extraTranslations);
mergeTranslations(messages.es.translations, {
  dashboard: { toasts: { loadError: "Error al cargar datos del dashboard" } },
  contactDrawer: { toasts: { loadParticipantsError: "Error al cargar participantes del grupo" } },
  messagesList: {
    video: {
      unsupported: "Su navegador no admite reproducción de video.",
      loadError: "❌ Error al cargar video",
    },
  },
  messageInput: {
    flowProcessingAlert: {
      title: "Flujo en Ejecución:",
      description: "Campo de mensaje temporalmente deshabilitado.",
    },
    templateRequiredAlert: {
      title: "Ventana de 24h Expirada:",
      description: "Para retomar la conversación, envíe primero un template Meta.",
    },
  },
  floup: {
    alerts: {
      saveError: "Error al guardar el Follow UP. Verifique la consola para más detalles.",
      deleteError: "Error al eliminar el Follow UP. Verifique la consola para más detalles.",
    },
  },
});
mergeTranslations(messages.es.translations, {
  common: { statusLabel: "Status", labels: { all: "Todos" } },
  salesReport: {
    title: "Informe de Ventas",
    toasts: { selectPeriod: "Por favor, seleccione el período" },
    filters: { startDate: "Fecha Inicial", endDate: "Fecha Final", agent: "Agente", noSaleReason: "Motivo de No Venta", finishReason: "Motivo de Finalización" },
    buttons: { generate: "Generar Informe", generating: "Generando..." },
    stats: { totalSales: "Total de Ventas", totalSalesValue: "Valor Total de Ventas", noSales: "No Ventas", averageTicketsByAgent: "Promedio de Tickets por Agente" },
    sections: { noSaleReasons: "Motivos de No Venta", finishedTickets: "Tickets Finalizados", agentPerformance: "Rendimiento por Agente" },
    table: { agent: "Agente", date: "Fecha", saleValue: "Valor de la Venta", noSaleReason: "Motivo de No Venta", finishReason: "Motivo de Finalización", totalSales: "Total de Ventas", totalSalesValue: "Valor Total de Ventas", noSales: "No Ventas", totalTickets: "Total de Tickets", averageTickets: "Promedio de Tickets" },
  },
  schedules: {
    toasts: { sentEditBlocked: "Este agendamiento ya fue enviado y no puede editarse.", sentDeleteBlocked: "No es posible eliminar un agendamiento ya enviado.", noPermissionRedirect: "¡Esta empresa no tiene permiso para acceder a esta página! Redirigiendo." },
    confirmations: { deleteSchedule: "¿Desea eliminar este agendamiento?" },
    aria: { calendarView: "vista del calendario", monthView: "vista mensual", weekView: "vista semanal", dayView: "vista diaria", agendaView: "agenda" },
  },
  home: {
    themeToggle: "Alternar tema",
    aria: { openMenu: "Abrir menú", dashboardMockup: "Mockup del dashboard" },
    nav: { features: "Recursos", integrations: "Integraciones", plans: "Planes", contact: "Contacto", login: "Entrar", startNow: "Comenzar Ahora" },
    hero: { badge: "SaaS Omnichannel para Atención y Ventas", title: "Automatice su atención y escale sus ventas con TicketWhats", description: "Centralice WhatsApp, Instagram y Facebook en una plataforma moderna con IA, campañas inteligentes y automatizaciones avanzadas.", startFree: "Comenzar Gratis", viewDemo: "Ver Demostración" },
    stats: { uptime: "Uptime", messages: "Mensajes", support: "Soporte", integrations: "Integraciones" },
    dashboard: { title: "TicketWhats Dashboard", activeTickets: "Tickets activos", campaignsToday: "Campañas hoy", customerMessage: "Cliente: Hola, necesito soporte", botMessage: "Bot IA: Ya te conecté al sector ideal.", agentMessage: "Agente: Perfecto, te ayudaré ahora." },
    floating: { conversion: "+42% Conversión", aiActive: "IA Activa", apiOnline: "API Online" },
    features: { title: "Recursos para equipos de alto rendimiento", description: "Una stack completa para atención, automatización y crecimiento con experiencia premium.", empty: "Aún no hay recursos registrados. Configure los recursos de los planes en el panel administrativo." },
    integrations: { title: "Integraciones que aceleran su operación", description: "Conecte sus canales, automatizaciones y datos sin fricción.", empty: "Aún no hay integraciones registradas. Mostrando integraciones predeterminadas." },
    ai: { title: "Automatización con Inteligencia Artificial", description: "Respuestas automáticas, enrutamiento inteligente, campañas con contexto y atención híbrida para aumentar la eficiencia sin perder calidad.", items: { contextReplies: "Respuestas rápidas con contexto del cliente", priorityRouting: "Clasificación y distribución automática por prioridad", smartWorkflows: "Workflows inteligentes con fallback humano", realtimeInsights: "Insights operativos con métricas en tiempo real" }, panelTitle: "Asistente IA", sampleUser: "Cliente: Quiero saber sobre el plan Business", sampleBotOne: "IA: Puedo mostrarte precio, recursos y agendar una demo ahora.", sampleBotTwo: "IA: ¿Deseas recibir la propuesta por WhatsApp o email?" },
    pricing: { title: "Planes para cada etapa de crecimiento", description: "Elija el plan ideal y evolucione sin cambiar de plataforma.", loading: "Cargando planes...", featured: "Más Elegido", empty: "No se encontró ningún plan público activo en la base de datos." },
    cta: { title: "¿Listo para transformar su atención?", description: "Active TicketWhats y opere con más velocidad, inteligencia y previsibilidad.", viewPlatform: "Ver Plataforma" },
    footer: { description: "Plataforma premium para atención omnichannel, automatización y crecimiento de ingresos.", product: "Producto", company: "Empresa", support: "Soporte", createAccount: "Crear cuenta", docs: "Documentación", api: "API", terms: "Términos", copyright: "© {{year}} TicketWhats. Todos los derechos reservados." },
  },
  campaignReport: {
    toasts: { noPermissionRedirect: "¡Esta empresa no tiene permiso para acceder a esta página! Redirigiendo.", shippingLoadError: "Error al cargar datos de envío" },
    shippingStatus: { delivered: "Entregado", processing: "Procesando", pending: "Pendiente", sent: "Enviado", read: "Leído", played: "Reproducido", failedRetryable: "Falló, intentando nuevamente", failed: "Falló", cancelled: "Cancelado" },
    whatsappConnection: "Conexión WhatsApp",
    usedTag: "Tag Utilizada",
    notSpecified: "No especificado",
    notScheduled: "No agendado",
    notCompleted: "No concluido",
    messageDetails: "Detalles de los Mensajes",
    exportExcel: "Exportar Excel",
    messagesTableAria: "tabla de mensajes",
    loading: "Cargando...",
    noMessagesFound: "No se encontraron mensajes",
    table: { recipient: "Destinatario", message: "Mensaje", sentAt: "Enviado en", deliveredAt: "Entregado en", attemptsNextRetry: "Intentos / Próximo Reenvío" },
  },
  messageModal: {
    attachedFile: "Archivo adjunto: {{fileName}}",
    form: { name: "Nombre", intervalValue: "Valor del Intervalo", sendHowManyTimes: "Enviar cuántas veces", showUser: "Mostrar Usuario", createTicket: "Crear Ticket" },
    placeholders: { connection: "Conexión", contacts: "Contactos", users: "Usuarios" },
    options: { sendNormallyOnNonBusinessDays: "Enviar normalmente en días no hábiles", sendOneBusinessDayBefore: "Enviar un día hábil antes", sendOneBusinessDayAfter: "Enviar un día hábil después" },
  },
  flowBuilderInputModal: {
    question: { title: "Pregunta", tooltip: ["La pregunta que se enviará al usuario. Puede incluir variables usando $", "{nombreVariable}"].join(""), label: "Escriba la pregunta", placeholder: ["Ej: Hola $", "{nombre}, ¿cuál es tu edad?"].join("") },
    variables: { available: "Variables disponibles (clic para insertar):" },
    variableName: { title: "Nombre de la variable", tooltip: "Nombre de la variable donde se almacenará la respuesta. No use espacios ni caracteres especiales.", label: "Nombre de la variable", placeholder: "Ej: edad_cliente", helper: "La respuesta del usuario se almacenará en esta variable" },
    howItWorks: { title: "Cómo funciona", description: "Este nodo enviará la pregunta al usuario y esperará una respuesta. Cuando el usuario responda, el valor se almacenará en la variable especificada y el flujo continuará al siguiente nodo." },
  },
  helpsManager: {
    form: { title: "Título" },
    table: { aria: "tabla de ayudas", title: "Título", video: "Video" },
    toasts: { loadError: "No fue posible cargar la lista de registros", operationError: "No fue posible realizar la operación. Verifique si ya existe una ayuda con el mismo nombre o si los campos fueron completados correctamente", deleteError: "No fue posible realizar la operación" },
    confirmation: { deleteTitle: "Eliminación de Registro", deleteMessage: "¿Realmente desea eliminar este registro?" },
  },
});

mergeTranslations(messages.es.translations, {
  common: {
    note: "Nota",
    noData: "Sin datos",
    buttons: { save: "Guardar", cancel: "Cancelar", update: "Actualizar", search: "Buscar", loadMore: "Cargar más..." },
    status: { error: "Error", inactive: "Inactiva", online: "Online", offline: "Offline", connected: "Conectado", disconnected: "Desconectado" },
    loading: { searching: "Buscando..." },
  },
  connections: {
    contactsImport: {
      title: "¿Importar Contactos de WhatsApp?",
      message: "Encontramos {{count}} contactos en WhatsApp. ¿Desea importarlos al sistema?",
      note: "La importación puede tardar algunos minutos dependiendo de la cantidad de contactos. Puede seguir el progreso en la página de Contactos.",
      later: "Ahora No",
      confirm: "Sí, Importar",
    },
    transfer: {
      title: "Transferencia de Tickets",
      source: "Origen",
      target: "Destino",
      descriptionStart: "Para transferir los tickets, seleccione la conexión de",
      descriptionMiddle: "(desde donde se moverán los tickets) y la conexión de",
      descriptionEnd: "(hacia donde se transferirán los tickets). Todas las atenciones activas de la conexión de origen se moverán a la conexión de destino.",
    },
    table: { channel: "Canal" },
    aria: { syncTemplates: "Sincronizar templates", copyWebhook: "Copiar webhook" },
  },
  contacts: {
    group: "Grupo",
    importFileTitle: "Importar contactos desde archivo",
    bulk: { selectContactAria: "Seleccionar contacto {{name}}" },
  },
  signup: {
    document: {
      label: "CPF o CNPJ",
      helper: "Ingrese CPF (11 dígitos) o CNPJ (14 dígitos)",
      cpfValid: "¡CPF válido!",
      cpfInvalid: "¡CPF inválido!",
      cnpjValidCompanyFilled: "¡CNPJ válido! Nombre de la empresa completado automáticamente.",
      invalidOrNotFound: "Documento inválido o no encontrado en Receita Federal",
      validationError: "Error al validar el documento. Inténtelo nuevamente.",
    },
  },
  wallets: { notFound: "Billetera no encontrada" },
  invoices: { table: { status: "Status" } },
  financial: {
    attention: "Atención",
    expiredSubscription: "Su suscripción está vencida. Contacte al soporte para regularizar su situación.",
  },
  helps: { youtubePlayerTitle: "Reproductor de video de YouTube" },
  tickets: {
    globalSearch: {
      title: "Búsqueda Global en la atención",
      results: "{{count}} resultado(s)",
      minChars: "Escriba al menos 2 caracteres para buscar en contactos, tickets y mensajes.",
      noResults: "No se encontraron resultados para esta búsqueda.",
      placeholder: "Buscar en contactos, tickets y mensajes",
    },
    search: { filterAria: "Filtrar" },
  },
  newTicketModal: {
    newAttendance: "Nueva Atención",
    attendanceSector: "Sector de Atención",
    sendChannel: "Canal de Envío",
    selectSector: "Seleccione el sector...",
    selectConnection: "Seleccione la conexión...",
    otherUser: "Otro usuario",
    errors: { selectQueue: "Seleccione una fila" },
  },
  contactListItemFromContactsModal: {
    title: "Buscar en la lista de contactos",
    searchPlaceholder: "Buscar por nombre o número...",
    selectedOne: "contacto seleccionado",
    selectedMany: "contactos seleccionados",
    noContactsFound: "No se encontró ningún contacto",
    noContactsAvailable: "No hay contactos disponibles",
    add: "Agregar",
    adding: "Agregando...",
  },
  messageModal: { placeholders: { tags: "Tags" } },
  messageInput: {
    audioMessage: "🎧 Mensaje de audio",
    aria: {
      clearReply: "Limpiar respuesta",
      sendTemplateRequired: "Enviar template obligatorio",
      emojiPicker: "Abrir selector de emojis",
      uploadMedias: "Adjuntar medios",
      uploadMediaFile: "Adjuntar foto o video",
      uploadDocument: "Adjuntar documento",
      toggleSignature: "Alternar firma",
      triggerFlow: "Disparar flujo",
      pendingModeSwitch: "Alternar modo de atención pendiente",
      pendingModeNote: "Usar observación del ticket",
      cancelForward: "Cancelar reenvío",
      sendMessage: "Enviar mensaje",
      cancelRecording: "Cancelar grabación",
      sendRecordedAudio: "Enviar audio grabado",
      showRecorder: "Abrir grabador",
      privateMessage: "Alternar mensaje privado",
      scheduleMessage: "Agendar mensaje",
    },
  },
  floupDashboard: {
    title: "Dashboard de Follow UP por Etapas",
    followUp: "Follow UP",
    nextRun: "Próxima",
    recentError: "⚠️ Error reciente",
    step: "Etapa",
    steps: "Etapas",
    contacts: "Contactos",
    channel: "Canal",
    noMessage: "Sin mensaje",
    emptyStepContacts: "Ningún contacto en esta etapa",
    selectFloup: "Seleccione un Floup para ver las etapas",
    noData: "No se encontraron datos para este Floup",
    noSteps: "No se encontró ninguna etapa",
  },
});

mergeTranslations(messages.es.translations, {
  common: {
    yes: "Sí",
    no: "No",
    words: { and: "y" },
    time: { seconds: "segundos" },
    buttons: {
      previous: "Anterior",
      next: "Siguiente",
      save: "Guardar",
      refresh: "Actualizar",
      cancel: "Cancelar",
    },
  },
  globalSearch: {
    title: "Búsqueda Global",
    subtitle: "Encuentra contactos, fragmentos de conversación y tickets en un solo lugar.",
    loading: "Buscando en contactos, mensajes y tickets...",
    placeholders: {
      all: "Busca en contactos, mensajes y tickets",
      messages: "Busca por palabras, frases o fragmentos de la conversación",
      tickets: "Busca por ticket, contacto, número o último mensaje",
      contacts: "Busca por nombre, número o correo del contacto",
    },
    fallbacks: {
      noName: "Sin nombre",
      contact: "Contacto",
      noContact: "Sin contacto",
      noTextMessage: "[mensaje sin texto]",
      noQueue: "Sin cola",
      notAssigned: "No asignado",
      noLastMessage: "Sin último mensaje",
    },
    meta: {
      company: "Empresa",
      tickets: "Tickets",
      lastInteraction: "Última interacción",
      status: "Estado",
      queue: "Cola",
      responsible: "Responsable",
    },
    hints: {
      openConversation: "Haz clic para abrir la conversación",
      openContact: "Haz clic para abrir el contacto",
      openMessage: "Haz clic para abrir directamente en el mensaje",
      openTicket: "Haz clic para abrir el ticket",
    },
    empty: {
      title: "Búsqueda global inteligente",
      minChars: "Escribe al menos 2 caracteres para buscar en toda la base.",
      noGlobalResults: "No se encontraron resultados en la búsqueda global.",
      noTabResults: "No se encontraron resultados en esta pestaña.",
    },
    types: { contact: "Contacto", message: "Mensaje", ticket: "Ticket" },
    results: { combined: "{{count}} resultado(s) combinados en las tres categorías" },
    pagination: { page: "Página", results: "{{count}} resultado(s)" },
    tabs: { all: "Todos", contacts: "Contactos", messages: "Mensajes", tickets: "Tickets" },
  },
  campaignsWarmup: {
    title: "Campaign Warmup Control Center",
    subtitle: "Vista operativa densa por conexión, con capacidad, reputación, eventos, historial y acciones administrativas directo en la pantalla principal.",
    toasts: {
      actionSuccess: "¡Acción ejecutada con éxito!",
      blockReasonRequired: "Informe el motivo del bloqueo.",
      connectionBlocked: "Conexión bloqueada administrativamente.",
    },
    stages: {
      blocked: "Nivel 0 · Bloqueado",
      new: "Nivel 1 · Nuevo",
      initial: "Nivel 2 · Inicial",
      moderate: "Nivel 3 · Moderado",
      conservative: "Nivel 4 · Conservador",
      normal: "Nivel 5 · Normal",
      high: "Nivel 6 · Alto",
    },
    status: {
      blocked: "Bloqueado",
      awaitingBaseline: "Esperando baseline",
      healthy: "Saludable",
      attention: "Atención",
      critical: "Crítico",
      campaignsReleased: "Campañas liberadas",
    },
    labels: {
      manualBlock: "Bloqueo manual",
      automaticBlock: "Bloqueo automático",
      number: "Número",
      connections: "Conexiones",
      sentToday: "Envíos hoy",
      blockReason: "Motivo del bloqueo",
    },
    fallbacks: {
      campaign: "Campaña #{{id}}",
    },
    meta: {
      status: "Estado",
      lastSend: "Último envío",
      lastStageChange: "Último cambio de etapa",
    },
    empty: {
      noData: "Sin datos",
      noStage: "Sin etapa",
      noBaseline: "Sin baseline",
      noOperationalBaseline: "Sin baseline operativo",
      noCampaignBaseline: "Sin baseline de campaña todavía",
      noAction: "Sin acción",
      noRecentHistory: "Sin historial reciente.",
      noActiveCampaigns: "Ninguna campaña activa.",
      noCriticalRecommendations: "Ninguna recomendación crítica en este momento.",
      awaitingCampaignData: "Esperando datos de campaña para generar recomendaciones.",
      noConnectionFound: "Ninguna conexión encontrada",
      noConnectionDescription: "Cuando haya conexiones con warmup de campañas, aparecerán aquí con una vista completa de operación.",
    },
    metrics: {
      healthScore: "Health Score",
      spamRiskScore: "Spam Risk Score",
      dailyLimitVsSent: "Límite diario x enviadas hoy",
      hourlyLimitVsSent: "Límite horario x enviadas en la hora",
      deliveryRate: "Delivery Rate",
      readRate: "Read Rate",
      replyRate: "Reply Rate",
      deliveredToday: "Delivered Today",
      readToday: "Read Today",
      repliesToday: "Replies Today",
      positiveReplies: "Respuestas positivas",
      negativeReplies: "Respuestas negativas",
      neutralReplies: "Respuestas neutras",
      optOuts: "Opt-outs",
      averageReplyTime: "Tiempo medio de respuesta",
      percentConsumed: "{{percent}}% consumido",
      successes: "Éxitos",
      failures: "Fallos",
      invalid: "Inválidos",
      score: "Score",
    },
    sections: {
      connectionCapacity: "Capacidad de la conexión",
      reputationVolume: "Reputación y volumen",
      dayEvents: "Eventos del día",
      periodPerformance: "Desempeño por período",
      recommendations: "Recomendaciones",
      recentHistory: "Historial reciente",
      activeCampaigns: "Campañas activas",
      analytics: "Vista analítica",
    },
    tabs: { today: "Hoy", sevenDays: "7 días", thirtyDays: "30 días" },
    hints: { lowerIsBetter: "Cuanto menor, mejor" },
    alerts: {
      manualBlockActive: "Bloqueo manual activo",
      automaticBlockActive: "Bloqueo automático activo",
      blockedUntil: "Bloqueado hasta {{date}}.",
      noBlockDetails: "Sin detalles del bloqueo.",
    },
    actions: {
      promote: "Promover",
      regress: "Rebajar",
      block: "Bloquear",
      unblock: "Desbloquear",
      resetCounters: "Restablecer contadores",
      confirmBlock: "Confirmar bloqueo",
    },
    kpis: {
      totalConnections: "Total de conexiones",
      monitoredNow: "Monitoreadas ahora",
      healthy: "Saludables",
      highScoreLowRisk: "Score alto y bajo riesgo",
      atRisk: "En riesgo",
      needReview: "Piden revisión operativa",
      blocked: "Bloqueadas",
      manualOrAutomatic: "Manual o automático",
      consumedCapacity: "Capacidad consumida",
      averageSpamRisk: "Spam Risk medio",
    },
    analytics: {
      healthy: "Saludables",
      blocked: "Bloqueadas",
      summary: "Resumen rápido de salud, distribución y consumo para lectura ejecutiva.",
      hide: "Ocultar análisis",
      show: "Mostrar análisis",
      dailyConsumption: "Consumo diario por conexión",
      operationalHealth: "Salud operativa",
      stageDistribution: "Distribución por etapa",
      quickIndicators: "Indicadores rápidos",
    },
    indicators: {
      noConnection: "Ninguna conexión encontrada para monitorear.",
      withoutBaseline: "{{count}} conexión(es) aún no tienen baseline suficiente para evaluación de salud.",
      risky: "{{count}} conexión(es) exigen atención por score de salud bajo o riesgo de spam alto.",
      blocked: "{{count}} conexión(es) están bloqueadas y dependen de revisión antes de escalar volumen.",
      nearLimit: "{{count}} conexión(es) ya consumieron más del 80% de la capacidad diaria.",
      stable: "Operación estable en este momento. Ninguna alerta crítica detectada.",
    },
    dialog: {
      blockConnectionTitle: "Bloquear conexión para campañas",
      blockConnectionDescription: "Informe el motivo del bloqueo administrativo. Esta justificación quedará registrada para auditoría operativa.",
    },
  },
  callHistoricals: {
    title: "Historial de Llamadas",
    searchPlaceholder: "Buscar por nombre o teléfono...",
    empty: "Ningún registro encontrado",
    stats: {
      total: "Total de Llamadas",
      rejected: "Llamadas Rechazadas",
      served: "Llamadas Atendidas",
      finished: "Llamadas Finalizadas",
    },
    columns: {
      name: "Nombre",
      phone: "Teléfono",
      agent: "Agente",
      dateTime: "Fecha/Hora",
      direction: "Dirección",
      status: "Estado",
      duration: "Duración",
      type: "Tipo",
      recording: "Grabación",
      actions: "Acciones",
    },
    status: {
      ended: "Finalizada",
      active: "Activa",
      ringing: "Sonando",
      busy: "Ocupado",
      noAnswer: "No atendida",
      rejected: "Rechazada",
    },
    direction: { outgoing: "Salida", incoming: "Entrada" },
    fallbacks: { receivedCall: "Llamada Recibida" },
    tooltips: { downloadAudio: "Descargar audio", makeCall: "Hacer llamada" },
  },
  campaignsConfig: {
    toasts: {
      noPermissionRedirect: "¡Esta empresa no tiene permiso para acceder a esta página! Estamos redirigiéndote.",
      saved: "Configuraciones guardadas",
    },
    sections: { intervals: "Intervalos" },
  },
  floup: {
    step: {
      title: "Paso {{order}}",
      emptyMessage: "Mensaje vacío",
      attachment: "Adjunto",
      message: "Mensaje",
      characterCount: "{{count}}/500 caracteres",
      value: "Valor",
      timeUnit: "Unidad de Tiempo",
      sendAfter: "Enviar después de {{value}} {{unit}}",
      attachmentLink: "Adjunto/Link",
      urlPlaceholder: "Pega la URL aquí",
      removeLink: "Eliminar link",
      removeMedia: "Eliminar media",
      removeStep: "Eliminar Paso",
      chooseFile: "Elegir Archivo",
      videoUnsupported: "Tu navegador no soporta el elemento de video.",
    },
    timeUnits: { minutes: "Minutos", hours: "Horas", days: "Días", weeks: "Semanas", months: "Meses", years: "Años" },
    mediaTypes: { link: "Link", upload: "Upload" },
    preview: { title: "Vista previa del Mensaje", attachmentHint: "El ícono de adjunto aparecerá aquí" },
    alerts: { uploadError: "Error al subir el archivo. Verifica la consola para más detalles." },
    stopConditions: {
      anyMessage: "1. Si el Contacto responde cualquier mensaje",
      keyword: "2. Si el Contacto responde una palabra clave",
      keywordLabel: "Palabra clave",
      keywordPlaceholder: "Ej: PARAR, CANCELAR, SALIR",
      ticketClosed: "3. Si el Ticket se Cierra",
    },
  },
  flowDefault: {
    title: "Flujo predeterminado",
    toasts: { deleted: "Flujo eliminado con éxito", updated: "Flujos predeterminados actualizados" },
    deleteConfirmation: "¿Está seguro de que desea eliminar este flujo? Todas las integraciones relacionadas se perderán.",
    selectFlowPlaceholder: "Elija un flujo",
    welcomeFlow: {
      title: "Flujo de bienvenida",
      description: "Este flujo se dispara solo para nuevos contactos, personas que no están en su lista de contactos y enviaron un mensaje",
    },
    defaultResponseFlow: {
      title: "Flujo de respuesta predeterminada",
      description: "La Respuesta Predeterminada se envía con cualquier carácter diferente de una palabra clave. ¡ATENCIÓN! Se disparará si la atención ya está cerrada y pasaron 6 horas desde su cierre.",
    },
  },
  subscription: {
    title: "Suscripción",
    licensePeriod: "Período de Licencia",
    licenseDueToday: "¡Tu licencia vence hoy!",
    licenseDueDays: "¡Tu licencia vence en {{days}} días!",
    billingEmail: "Email de facturación",
    subscribeNow: "¡Suscríbete Ahora!",
  },
  messagesApi: {
    toasts: {
      noPermissionRedirect: "¡Esta empresa no tiene permiso para acceder a esta página! Estamos redirigiéndote.",
      messageSent: "Mensaje enviado con éxito",
    },
    buttons: { send: "Enviar" },
    docs: {
      endpoint: "Endpoint",
      method: "Método",
      headers: "Headers",
      registeredToken: "token registrado",
      formData: "FormData",
      userIdHint: "ID de usuario o",
      queueIdHint: "ID de la cola o",
      file: "archivo",
    },
  },
});

mergeTranslations(messages.es.translations, {
  common: {
    loading: { saving: "Guardando..." },
    buttons: {
      add: "Agregar",
      edit: "Editar",
      remove: "Eliminar",
      close: "Cerrar",
      saveChanges: "Guardar cambios",
    },
  },
  flowBuilder: {
    nodes: {
      media: { unsupportedHtml5: "Tu navegador no soporta HTML5" },
      audio: { title: "Audio", recorded: "Grabado al momento", sent: "Audio enviado" },
      video: { title: "Video" },
      message: { title: "Mensaje" },
      attendant: { title: "Agente" },
      removeTag: { title: "Eliminar Tag" },
      switchFlow: { title: "Cambiar Flujo" },
      question: { title: "Pregunta" },
      interval: { title: "Intervalo" },
      randomizer: { title: "Aleatorizador" },
      tag: { title: "Tag" },
      menu: { title: "Menú" },
      ticket: { title: "Cola" },
      image: { title: "Imagen" },
      openAi: { assistant: "Asistente IA GPT" },
      gemini: { assistant: "Asistente IA Google" },
      input: {
        responseVariable: "Variable para almacenar respuesta:",
        valueTooltip: "Valor: {{value}}",
        variableNotDefined: "Variable no definida",
        usingVariables: "Usando variables: {{variables}}",
        alwaysAsk: "Preguntar siempre (aunque la variable ya exista)",
      },
      variable: {
        title: "Variable Global",
        name: "Nombre de la variable",
        value: "Valor",
        helper: "Puedes usar valores estáticos o referencias como " + String.fromCharCode(36) + "{otraVariable}",
        saved: "¡Guardado!",
        saveButton: "Guardar variable",
        savedSuccess: "¡Variable guardada con éxito!",
      },
      httpRequest: {
        presetsTitle: "Webhooks Preconfigurados",
        selectPreset: "Seleccionar preset",
        selectPresetPlaceholder: "Elige una configuración lista...",
        systemPreset: "SISTEMA",
        usingPreset: "Usando preset:",
        urlFromPreset: "URL (del preset)",
        urlPlaceholder: "https://api.ejemplo.com/webhook",
        urlHelper: "Puedes editar la URL base del preset si es necesario",
        method: "Método",
        testRequest: "Probar Solicitud",
        apiResponse: "Respuesta de la API:",
        viewFullResponse: "Ver respuesta completa",
        hideAdvanced: "Ocultar avanzado",
        showAdvanced: "Mostrar avanzado",
        advancedWarning: "Las configuraciones avanzadas pueden sobrescribir las configuraciones del preset",
        timeoutMs: "Timeout (ms)",
        queryParams: "Parámetros de Query",
        key: "Clave",
        value: "Valor",
        addParam: "Agregar Parámetro",
        headersJson: "Encabezados (JSON)",
        headersPlaceholder: "{\"Authorization\": \"Bearer token\", \"Custom-Header\": \"XYZ\"}",
        requestBodyJson: "Cuerpo de la solicitud (JSON)",
        editRequestBody: "Editar cuerpo de la solicitud",
        hideMapping: "Ocultar Variables de la Respuesta",
        mapResponseVariables: "Mapear Variables de la Respuesta",
        mapResponseData: "Mapear datos de la respuesta a variables",
        path: "Ruta",
        pathPlaceholder: "ej: data.user.id",
        variableName: "Nombre de la variable",
        variablePlaceholder: "ej: userId",
        addVariable: "Agregar variable",
        usefulTips: "Consejos útiles:",
        apiResponseTip: "• La respuesta completa de la API se guarda automáticamente en la variable global",
        variableUsageTip: "Puedes usar " + String.fromCharCode(36) + "{nombreDeVariable} en la URL y el cuerpo de la solicitud para incluir valores de variables.",
        fullApiResponse: "Respuesta completa de la API",
        toasts: { presetError: "Error al aplicar la configuración del preset" },
      },
    },
    modals: {
      singleBlock: {
        addTitle: "Agregar contenido al flujo",
        addMenuTitle: "Agregar menú al flujo",
        editTitle: "Editar contenido",
        variables: "Variables",
        toasts: {
          emptyMessage: "¡Campos de mensaje vacíos!",
          invalidInterval: "¡El intervalo no puede ser 0 ni mayor que 120!",
          contentAdded: "¡Contenido agregado con éxito!",
          deleteEmptyCards: "Elimina las tarjetas vacías (Imagen, Audio y Video)",
        },
      },
      media: {
        image: "Imagen",
        audio: "Audio",
        video: "Video",
        text: "Texto",
        interval: "Intervalo",
        document: "Documento",
        message: "Mensaje",
        timeInSeconds: "Tiempo en segundos",
        uploadImage: "Enviar imagen",
        uploadAudio: "Enviar audio",
        uploadVideo: "Enviar video",
        uploadDocument: "Enviar Documento",
        sendAsRecordedAudio: "Enviar como audio grabado al momento",
        viewDocument: "Visualizar Documento",
        addAudioTitle: "Agregar audio al flujo",
        editAudioTitle: "Editar audio",
        addImageTitle: "Agregar imagen al flujo",
        editImageTitle: "Editar imagen",
        addVideoTitle: "Agregar video al flujo",
        editVideoTitle: "Editar video",
        toasts: {
          audioAdded: "¡Audio agregado con éxito!",
          imageAdded: "¡Imagen agregada con éxito!",
          videoAdded: "¡Video agregado con éxito!",
        },
        errors: {
          fileTooLarge2mb: "¡El archivo es muy grande! Máximo 2MB",
          fileTooLarge5mb: "¡El archivo es muy grande! Máximo 5MB",
          fileTooLarge10mb: "¡El archivo es muy grande! Máximo 10MB",
          fileTooLarge20mb: "¡El archivo es muy grande! Máximo 20MB",
        },
      },
      randomizer: {
        addTitle: "Agregar un aleatorizador al flujo",
        editTitle: "Editar aleatorizador",
        percentageAria: "Porcentaje",
        errors: {
          addIntervalValue: "Agrega el valor de intervalo",
          maxTimeReached: "Tiempo máximo alcanzado: 120 segundos",
        },
      },
      conditionCompare: {
        newTitle: "Nueva Comparación",
        editTitle: "Editar Comparación",
        value1: "Valor 1",
        value2: "Valor 2",
        valueHelper: "Puede ser texto fijo o variable (ej: " + String.fromCharCode(36) + "{variable})",
        value1Tooltip: "Este es el valor que será comparado. Puede ser texto fijo o una variable.",
        value2Tooltip: "Este es el valor con el que se comparará el primer valor. Puede ser texto fijo o una variable.",
        valuePlaceholder: "Escribe un valor o selecciona una variable",
        operator: "Operador de Comparación",
        variableButton: "Variable",
        selectVariable: "Seleccionar Variable",
        variableHelp: "Estas son variables de ejemplo. Configura las variables reales en el nodo de Variable Global u otros nodos del flujo.",
        searchVariable: "Buscar variable...",
        configureVariableNode: "(Configura en el nodo de Variable Global)",
        noVariables: "Ninguna variable encontrada",
        categories: { contact: "Contacto", message: "Mensaje" },
        variables: {
          contactName: "Nombre del contacto",
          contactEmail: "Email del contacto",
          contactPhone: "Teléfono del contacto",
          lastMessage: "Último mensaje recibido",
          lastContactDate: "Fecha del último contacto",
          apiResponse: "Respuesta de la última solicitud HTTP",
        },
        errors: {
          firstRequired: "El primer valor es obligatorio",
          secondRequired: "El segundo valor es obligatorio para este operador",
        },
        operators: {
          equals: "Igual a",
          notEquals: "Diferente de",
          contains: "Contiene",
          greaterThan: "Mayor que",
          lessThan: "Menor que",
          greaterOrEqual: "Mayor o igual a",
          lessOrEqual: "Menor o igual a",
          startsWith: "Empieza con",
          endsWith: "Termina con",
          isEmpty: "Está vacío",
          isNotEmpty: "No está vacío",
        },
      },
      openAi: {
        addTitle: "Agregar OpenAI al flujo",
        editTitle: "Editar OpenAI del flujo",
        basicSettings: "Configuraciones Básicas - OpenAI",
        apiKey: "API Key OpenAI",
        model: "Modelo OpenAI",
        voiceSettings: "Configuraciones de Voz (Opcional)",
        responseType: "Tipo de Respuesta",
        voiceKey: "Voice Key (Azure)",
        voiceKeyPlaceholder: "Clave de Azure Speech Service",
        voiceRegion: "Voice Region (Azure)",
        voiceRegionPlaceholder: "ej: brazilsouth",
        behaviorTooltip: "Configura cómo OpenAI debe comportarse en el flujo",
        validation: {
          voiceKeyRequired: "Voice Key es obligatoria para síntesis de voz",
          voiceRegionRequired: "Voice Region es obligatoria para síntesis de voz",
        },
      },
      gemini: {
        addTitle: "Agregar Gemini al flujo",
        editTitle: "Editar Gemini del flujo",
        basicSettings: "Configuraciones Básicas - Google Gemini",
        apiKey: "API Key Google AI",
        model: "Modelo Gemini",
        behaviorTooltip: "Configura cómo Gemini debe comportarse en el flujo",
      },
      ai: {
        assistantName: "Nombre del Asistente",
        systemPrompt: "Prompt del Sistema",
        systemPromptPlaceholder: "Describe cómo la IA debe comportarse, qué información debe recopilar y cómo debe responder...",
        temperature: "Temperatura",
        temperatureHelper: "0 = conservador, 2 = creativo",
        maxTokens: "Max Tokens",
        maxTokensHelper: "Tamaño máximo de la respuesta",
        maxMessages: "Max Mensajes",
        maxMessagesHelper: "Historial de contexto",
        flowBehavior: "Comportamiento del Flujo",
        flowMode: "Modo de Funcionamiento",
        permanent: "Permanente",
        endFlowHere: "Cerrar flujo aquí",
        permanentDescription: "El usuario sigue conversando con la IA hasta pedir transferencia o finalizar",
        temporary: "Temporal",
        returnToFlow: "Vuelve al flujo después",
        temporaryDescription: "La IA ejecuta una tarea específica y luego retorna al flujo normal",
        temporarySettings: "⏱️ Configuraciones del Modo Temporal",
        temporarySettingsDescription: "Configura cuándo la IA debe parar y retornar al flujo",
        maxInteractions: "Máximo de Interacciones",
        maxInteractionsHelper: "Número máximo de mensajes antes de volver al flujo (0 = ilimitado)",
        timeoutMinutes: "Timeout (minutos)",
        timeoutHelper: "Tiempo límite antes de volver al flujo (0 = sin límite)",
        continueKeywords: "Palabras clave para Continuar Flujo",
        keywordPlaceholder: "Escribe una palabra clave",
        continueKeywordsHelper: "Cuando el usuario envíe una de estas palabras, el flujo continuará automáticamente",
        objective: "Objetivo de la IA",
        objectiveHelper: "Describe lo que la IA debe completar (ej: 'Recopilar nombre, email y teléfono')",
        objectivePlaceholder: "Ej: Recopilar datos del cliente, Calificar interés, Diagnosticar problema...",
        autoComplete: "Auto completar al alcanzar el objetivo",
        autoCompleteHelper: "La IA analizará automáticamente si completó el objetivo y volverá al flujo",
        transferQueueId: "ID de la Cola (para transferencia)",
        transferQueueIdHelper: "ID de la cola a donde transferir si el usuario pide agente (0 = no transferir)",
        validation: {
          invalidModel: "Modelo inválido",
          objectiveRequired: "El objetivo es obligatorio cuando auto completar está activo",
        },
      },
    },
  },
});

mergeTranslations(messages.es.translations, {
  common: {
    title: "Título",
    name: "Nombre",
    description: "Descripción",
    actions: "Acciones",
    settings: { general: "Configuraciones Generales" },
    buttons: { add: "Agregar", back: "Volver" },
    toasts: { operationUpdated: "Operación actualizada con éxito." },
  },
  settings: {
    components: {
      about: {
        subtitle: "Sistema de Atención vía WhatsApp",
        systemVersions: "Versiones del Sistema",
        checkUpdates: "Verificar actualizaciones",
        systemStatus: "Estado del Sistema",
        refreshInfo: "Actualizar información",
        online: "Online",
        memoryUsage: "Memoria en Uso",
        platform: "Plataforma",
        availableFeatures: "Recursos Disponibles",
        footer: "Desarrollado para mejorar la atención al cliente",
        companyId: "Empresa ID",
        user: "Usuario",
        toasts: {
          whatsappUpdated: "Versión de WhatsApp actualizada: {{version}}",
          whatsappAlreadyUpdated: "La versión de WhatsApp ya está actualizada",
          adminOnly: "Solo los administradores pueden verificar actualizaciones",
          checkError: "Error al verificar actualizaciones",
        },
        features: {
          multichannel: "Atención multicanal vía WhatsApp",
          tickets: "Gestión de tickets y colas",
          chatbot: "Chatbot con flujos automatizados",
          campaigns: "Campañas y mensajes masivos",
          reports: "Informes y dashboards",
          apis: "Integración con APIs externas",
          agents: "Soporte para múltiples agentes",
          schedules: "Programación de mensajes",
        },
      },
      companyTimezone: {
        title: "Timezone de la empresa",
        description: "Las reglas de horario, automatizaciones y programaciones usan este timezone como referencia.",
        timezone: "Timezone",
        saveTimezone: "Guardar timezone",
        toasts: {
          companyDataError: "No fue posible cargar los datos completos de la empresa.",
          updateSuccess: "Timezone de la empresa actualizado con éxito.",
        },
      },
      finalizacaoAtendimento: {
        title: "Finalización de Atención",
        informSaleValue: "Informar valor de la venta al finalizar atención",
        informSaleValueHelp: "Cuando está habilitado, el campo de valor de venta aparecerá en el modal de finalización",
        reasonsTitle: "Motivos de Finalización",
        addReason: "Agregar Motivo",
        editReason: "Editar Motivo",
        reasonName: "Nombre del Motivo",
        reasonDescription: "Descripción (opcional)",
        noDescription: "Sin descripción",
        emptyReasons: "No hay motivos registrados. Haz clic en \"Agregar Motivo\" para comenzar.",
        confirmDelete: "¿Seguro que deseas eliminar este motivo?",
        toasts: {
          reasonNameRequired: "El nombre del motivo es obligatorio",
          reasonUpdated: "¡Motivo actualizado con éxito!",
          reasonCreated: "¡Motivo creado con éxito!",
          reasonSaveError: "Error al guardar motivo",
          reasonDeleted: "¡Motivo eliminado con éxito!",
          reasonDeleteError: "Error al eliminar motivo",
          configUpdated: "¡Configuración actualizada con éxito!",
          configUpdateError: "Error al actualizar configuración",
        },
      },
      homePageCustomization: {
        loading: "Cargando configuraciones...",
        colorCustomization: "Personalización de Colores",
        primaryColor: "Color Primario",
        backgroundColor: "Color de Fondo",
        textColor: "Color del Texto",
        accentColor: "Color de Destaque",
        fontCustomization: "Personalización de Fuentes",
        fontFamily: "Familia de Fuente",
        fontSize: "Tamaño de Fuente (px)",
        contentCustomization: "Personalización de Contenido",
        heroSection: "Sección Hero (Principal)",
        badgeText: "Texto del Badge",
        mainTitle: "Título Principal",
        featuresSection: "Sección de Recursos",
        pricingSection: "Sección de Planes",
        ctaSection: "Sección de Llamada a la Acción (CTA)",
        saveAll: "Guardar Todas las Configuraciones",
        toasts: {
          saveSuccess: "¡Configuración guardada con éxito!",
          saveError: "Error al guardar configuración",
          saveAllSuccess: "¡Todas las configuraciones fueron guardadas con éxito!",
          saveSettingsError: "Error al guardar configuraciones",
        },
      },
      infoMp: {
        title: "Integración con Mercado Pago",
        intro: "Para comenzar a integrar tu sistema con Mercado Pago, sigue estos pasos simples:",
        steps: {
          createAccount: "Crea una cuenta en Mercado Pago Developers",
          createApp: "Crea una aplicación en Mercado Pago Developers",
          productionCredentials: "Haz clic en Producción > Credenciales de producción",
          copyApiKey: "Haz clic en copiar y luego pega la clave en API key",
          webhooks: "En Mercado Pago, haz clic en notificaciones > webhooks",
          productionUrl: "En modo producción, pega la siguiente URL \"{{url}}\" y marca la opción pagos en Eventos",
        },
      },
      options: {
        textMessageType: "Texto",
        automaticPositionNotifications: "Notificaciones Automáticas de Posición",
        minimumIntervalMinutes: "Intervalo Mínimo (minutos)",
        minimumPositionDifference: "Diferencia Mínima de Posiciones",
        specialPositionMessage: "Mensaje Especial (Posición 1)",
        specialPositionPlaceholder: "¡Eres el próximo en ser atendido!",
        queuePositionHelper: "Escribe @ para insertar variables dinámicas (ej: {{name}}, {{position}}, {{queue}})",
        copyContactTab: "Configuración de Sigla para Copia de Contacto",
        removeCountryCode: "¿Eliminar código de país?",
        removeAreaCode: "¿Eliminar código de área?",
        removeNinthDigit: "¿Eliminar noveno dígito?",
        nameMsHelper: "Escribe @ para insertar variables dinámicas (ej: {{name}}, {{ms}})",
        nameQueueMsHelper: "Escribe @ para insertar variables dinámicas (ej: {{name}}, {{queue}}, {{ms}})",
        nameUserMsHelper: "Escribe @ para insertar variables dinámicas (ej: {{name}}, {{userName}}, {{ms}})",
      },
      uploaderCert: {
        certificateTab: "Certificado Efí - API PIX (p12)",
        chooseOption: "Elige una opción:",
        chooseCertificate: "Elegir Certificado Efí p12 API PIX",
        sendCertificate: "ENVIAR CERTIFICADO",
        toasts: {
          noPermission: "¡Sin permiso para acceder!",
          p12Only: "¡Usa solamente archivos en formato p12!",
          chooseFile: "¡Elige un archivo!",
          chooseDestination: "¡Elige un destino!",
          uploadSuccess: "¡Archivo enviado con éxito!",
        },
      },
    },
  },
  birthdaySettings: {
    title: "Configuraciones de Cumpleaños",
    loading: "Cargando configuraciones...",
    preview: "Vista previa:",
    userBirthdays: "Cumpleaños de Usuarios",
    enableUserNotifications: "Habilitar notificaciones de cumpleaños de usuarios",
    enableUserNotificationsHelp: "Cuando esté habilitado, se mostrará un modal de felicitación y se creará un comunicado automático",
    createUserAnnouncement: "Crear comunicado automático para cumpleaños de usuarios",
    createUserAnnouncementHelp: "Crea un comunicado automático que se muestra a todos los usuarios de la empresa",
    userMessage: "Mensaje de cumpleaños para usuarios",
    userMessageHelper: "Escribe @ para insertar variables dinámicas (ej: {{name}}, {{userName}})",
    contactBirthdays: "Cumpleaños de Contactos",
    enableContactMessages: "Habilitar envío automático de mensajes de cumpleaños para contactos",
    enableContactMessagesHelp: "Envía automáticamente mensaje de felicitación vía WhatsApp a contactos que cumplen años",
    contactMessage: "Mensaje de cumpleaños para contactos",
    contactMessageHelper: "Escribe @ para insertar variables dinámicas (ej: {{name}}, {{firstName}})",
    testMessage: "Probar Mensaje",
    sendTime: "Horario de envío de mensajes",
    sendTimeHelper: "Horario en que los mensajes automáticos serán enviados",
    whatsappConnection: "Conexión WhatsApp para Envío",
    selectConnection: "Selecciona una conexión",
    whatsappConnectionHelp: "Conexión WhatsApp que se usará para enviar mensajes de cumpleaños",
    createInternalAnnouncement: "Crear comunicado interno para cumpleaños de usuarios",
    createInternalAnnouncementHelp: "Crea un comunicado interno cuando un usuario cumple años",
    availableVariables: "Variables disponibles en los mensajes:",
    personName: "Nombre de la persona",
    personAgeContactsOnly: "Edad de la persona (solo para contactos)",
    saveSettings: "Guardar Configuraciones",
    prompts: { testContactId: "Escribe el ID de un contacto para prueba:" },
    toasts: {
      loadError: "Error al cargar configuraciones de cumpleaños",
      saveSuccess: "¡Configuraciones de cumpleaños guardadas con éxito!",
      saveError: "Error al guardar configuraciones",
      testSent: "¡Mensaje de prueba enviado!",
      testError: "Error al enviar mensaje de prueba",
    },
  },
  birthdayModal: {
    title: "¡Felicidades!",
    subtitle: "¡Hoy es un día especial!",
    loading: "Cargando cumpleañeros...",
    you: "¡Tú!",
    systemUser: "Usuario del Sistema",
    contact: "Contacto",
    ageOne: "{{count}} año",
    ageOther: "{{count}} años",
    sending: "Enviando...",
    messageAlreadySent: "Mensaje ya enviado",
    sendCongrats: "Enviar Felicitación",
    remindLater: "Recordar más tarde",
    gotIt: "¡Entendido, gracias!",
    toasts: {
      loadError: "Error al cargar cumpleañeros",
      messageSent: "¡Mensaje de felicitación enviado a {{name}}!",
      alreadySent: "El mensaje de cumpleaños ya fue enviado hoy a este contacto",
      sendError: "Error al enviar mensaje de cumpleaños",
    },
  },
  scheduleModal: {
    errors: {
      alreadySentReadonly: "Esta programación ya fue enviada y no puede modificarse.",
      validContactRequired: "Selecciona un contacto válido para la programación.",
    },
    titles: { sendError: "Error de Envío", messageStatus: "Mensaje {{status}}", group: "Grupo" },
    readonlyNotice: "Esta programación ya fue enviada y ya no puede modificarse.",
    form: {
      contact: "Contacto",
      bodyHelper: "Escribe @ para insertar variables dinámicas (ej: {{name}}, {{dataAgendamento}}, {{ms}})",
      quickMessageSearch: "Escribe para buscar respuestas rápidas...",
      noQuickMessages: "No se encontraron respuestas rápidas",
    },
    reminder: {
      title: "Recordatorio (Opcional)",
      description: "Define una fecha de recordatorio. El mensaje se enviará en el horario del recordatorio en lugar del horario original de la programación",
      date: "Fecha del Recordatorio",
      sameMessage: "El mensaje del recordatorio será el mismo que el mensaje programado.",
    },
    quickMessageAttachment: "De la Respuesta Rápida",
  },
  finalizacaoVendaModal: {
    title: "Finalización de Atención - Valor de Venta",
    loadingSettings: "Cargando configuraciones...",
    saleCompletedQuestion: "¿La venta fue concluida?",
    saleCompletedYes: "Sí, venta concluida",
    saleCompletedNo: "No, venta no concluida",
    saleValue: "Valor de la Venta (R$)",
    noSaleReason: "Motivo de No Venta *",
    finalizationReason: "Motivo de Finalización *",
    selectReason: "Selecciona un motivo",
    finishing: "Finalizando...",
    finishService: "Finalizar Atención",
    errors: {
      saleValueRequired: "Por favor, informa el valor de la venta.",
      noSaleReasonRequired: "Por favor, selecciona el motivo de no venta.",
      finalizationReasonRequired: "Por favor, selecciona el motivo de finalización.",
    },
  },
  contactImport: {
    fields: { name: "Nombre", number: "Número", birthDate: "Fecha de Nacimiento", wallet: "Cartera" },
    validateContacts: "Validar contactos en WhatsApp",
    importingWait: "Importando... Aguarde",
    importContacts: "Importar contactos",
    importResult: "Resultado de la importación",
    contactsCreated: "{{count}} contactos creados con éxito",
    contactsIgnored: "{{count}} contactos ignorados (número inválido o no marcados para actualizar)",
    importMore: "Importar más contactos",
    processingFile: "Procesando archivo...",
    invalidFileTitle: "¡Archivo inválido!",
    invalidFileDescription: "El archivo que intentaste importar no es válido. Por favor, intenta nuevamente con un archivo en el formato correcto.",
    tryAgain: "Intentar nuevamente",
    uploadAlt: "Upload",
    dropExcel: "Haz clic o arrastra un archivo Excel",
    acceptedFormats: "* Formatos aceptados: xls, xlsx, csv, txt",
    requiredColumnsHelp: "Para importar contactos, debes tener al menos las columnas de nombre y número de teléfono.",
    errors: {
      numberFieldRequired: "No fue seleccionado el campo de número del contacto",
      nameFieldRequired: "No fue seleccionado el campo de nombre del contacto",
      noContactsSelected: "Ningún contacto seleccionado",
      fieldAlreadySelected: "El campo {{field}} ya fue seleccionado.",
    },
    toasts: {
      importSuccess: "¡Importación realizada con éxito! {{count}} contactos importados.",
      importWithIgnored: "Importación concluida: {{imported}} contactos importados y {{ignored}} ignorados.",
      importFailed: "Falló la importación. Ningún contacto fue importado.",
    },
  },
  plansManager: {
    queues: "Colas",
    amount: "Valor",
    internalChat: "Chat Interno",
    externalApi: "API Externa",
    integrations: "Integraciones",
    tableAria: "tabla de planes",
    deleteTitle: "Eliminación de Registro",
    deleteMessage: "¿Realmente deseas eliminar este registro?",
    toasts: {
      loadError: "No fue posible cargar la lista de registros",
      operationValidationError: "No fue posible realizar la operación. Verifica si ya existe un plan con el mismo nombre o si los campos fueron completados correctamente",
      operationError: "No fue posible realizar la operación",
    },
  },
  companiesManager: { tableAria: "tabla de empresas" },
  quickMessageDialog: {
    official: "Oficial",
    messageHelper: "Escribe @ para insertar variables dinámicas (ej: {{name}}, {{userName}}, {{ms}})",
    attachMedia: "Adjuntar Media",
    editMedia: "Editar media",
    removeMedia: "Eliminar media",
    newFile: "Nuevo Archivo",
    newRecordedAudio: "Nuevo audio grabado",
    newAudio: "Nuevo Audio",
    chooseReplacementMedia: "Elige una nueva media para reemplazar:",
    chooseMediaOption: "Elige una opción para adjuntar media:",
    attachFile: "Adjuntar Archivo",
    recordAudio: "Grabar Audio",
    cancelEdit: "Cancelar Edición",
    type: "Tipo",
    value: "Valor",
  },
  whatsAppModal: {
    toasts: { clickSaveToRegister: "Haz clic en guardar para registrar los cambios" },
    tabs: { chatbot: "Chatbot", defaultFlow: "Flujo Predeterminado" },
    variableHelperNameMs: "Escribe @ para insertar variables dinámicas (ej: {{name}}, {{ms}})",
    welcomeFlowTitle: "Flujo de bienvenida",
    welcomeFlowDescription: "Este flujo se dispara solo para nuevos contactos, personas que no tienes en tu lista de contactos y que enviaron un mensaje",
  },
});

mergeTranslations(messages.es.translations, {
  chatMessages: {
    loadingOlderMessages: "Cargando mensajes antiguos...",
    doubleClickToReply: "Haz doble clic para responder",
    userFallback: "Usuario",
    cancelRecording: "Cancelar grabación",
    sendRecordedAudio: "Enviar audio grabado",
    cancelUpload: "Cancelar upload",
    sendUpload: "Enviar upload",
    emojiPicker: "Seleccionar emoji",
    showRecorder: "Mostrar grabador",
    upload: "Enviar archivo",
    messageFallback: "Mensaje",
    audioMessage: "Mensaje de audio",
    messageNotFound: "[mensaje no encontrado]",
  },
  cameraModal: {
    previewAlt: "Vista previa",
    retakePhoto: "Tomar otra foto",
    confirmPhoto: "Confirmar foto",
    capturePhoto: "Capturar foto",
    errors: {
      access: "No fue posible acceder a la cámara.",
      notFound: "No se encontró ninguna cámara en este dispositivo. Usa la opción de adjuntar imagen para enviar una foto.",
      permissionDenied: "Permiso de cámara denegado. Permite el acceso a la cámara en la configuración del navegador.",
      inUse: "La cámara está siendo usada por otra aplicación. Cierra otras aplicaciones que puedan estar usando la cámara.",
      unsupported: "Las configuraciones de la cámara no son compatibles. Intenta usar otro dispositivo.",
      accessWithDetails: "No fue posible acceder a la cámara: {{details}}",
    },
  },
  modalImageCors: {
    image: "Imagen",
    downloadImage: "Descargar imagen",
    sentAt: "Enviada en {{date}}",
    receivedAt: "Recibida en {{date}}",
    imageZoom: "Zoom de la imagen",
  },
  pdfPreview: {
    loadError: "Error al cargar archivo",
    downloadFile: "Descargar archivo",
    clickToDownload: "Haz clic para descargar",
  },
  audioRecorder: {
    microphoneAccessError: "Error al acceder al micrófono. Verifica los permisos.",
    recordAudio: "Grabar Audio",
    recording: "Grabando...",
    recordedAudio: "Audio grabado",
    confirmOrDelete: "Haz clic en confirmar para confirmar o en eliminar para quitar",
  },
  filters: {
    connections: "Selecciona las conexiones",
    contacts: "Contactos",
    tags: "Filtro por Tags",
    channels: "Selecciona los canales",
    queues: "Selecciona las colas",
    users: "Selecciona los agentes",
  },
});

mergeTranslations(messages.es.translations, {
  kanban: {
    toasts: {
      ticketTagUpdated: "Ticket Tag actualizado con éxito!",
      ticketTagRemoved: "Ticket Tag eliminado!",
      adminOnlyReorder: "Solo los administradores pueden reordenar las lanes del Kanban",
      lanesOrderUpdated: "Orden de las lanes actualizado con éxito",
      lanesOrderSaveError: "Error al guardar el orden de las lanes",
    },
    sort: {
      label: "Ordenar por",
      ticketNumber: "Número del Ticket",
      lastMessage: "Último Mensaje",
      valueDesc: "Valor (mayor a menor)",
      startDate: "Fecha de inicio",
      endDate: "Fecha de fin",
    },
    card: {
      ticketNumber: "Ticket n.º {{id}}",
      valueWithAmount: "Valor: R$ {{amount}}",
      assignValue: "Asignar Valor",
      remove: "Eliminar",
      viewTicket: "Ver Ticket",
      editOpportunityValue: "Editar Valor de la Oportunidad",
      assignOpportunityValue: "Asignar Valor de la Oportunidad",
      value: "Valor",
    },
  },
  contactModal: {
    placeholders: {
      email: "Dirección de email",
    },
    form: {
      lid: "LID (Linked Device ID)",
      jid: "JID (WhatsApp ID)",
      birthDate: "Fecha de Nacimiento",
    },
    helpers: {
      lid: "Identificador del dispositivo vinculado",
      jid: "Identificador completo de WhatsApp (JID)",
      birthDate: "Fecha de nacimiento para mensajes automáticos de cumpleaños",
      noFloup: "Este contacto no está en ningún Floup en este momento",
    },
    floup: {
      currentStep: "{{name}} - Etapa {{current}} de {{total}}",
      nextRun: "Próxima ejecución: {{date}}",
      active: "Floup activo",
      noneActive: "Ningún Floup activo",
    },
  },
  queueModal: {
    toasts: {
      clickSaveToRegister: "Haz clic en guardar para registrar los cambios",
    },
    tabsAria: "Pestañas de configuración de la cola",
    minutes: {
      one: "1 minuto",
      two: "2 minutos",
      three: "3 minutos",
      four: "4 minutos",
      five: "5 minutos",
      ten: "10 minutos",
      fifteen: "15 minutos",
      thirty: "30 minutos",
      fortyFive: "45 minutos",
      sixty: "60 minutos",
    },
    randomMode: {
      random: "Aleatorio",
      ordered: "Ordenado",
    },
    form: {
      selectRandomMode: "Selecciona el tipo de rotación",
    },
  },
  userModal: {
    form: {
      birthDate: "Fecha de Nacimiento",
      birthDateHelper: "Fecha de nacimiento para notificaciones de cumpleaños",
      saleFinalization: "Finalización con Valor de Venta",
      enabled: "Habilitado",
      disabled: "Deshabilitado",
    },
    status: {
      unknown: "Desconocido",
      online: "Online",
      offline: "Offline",
    },
  },
  notifications: {
    openNotifications: "Abrir notificaciones",
  },
});

mergeTranslations(messages.es.translations, {
  campaignsPhrase: {
    title: "Campañas de Flujo",
    buttons: {
      new: "Nueva Campaña",
    },
    columns: {
      name: "Nombre",
      connections: "Conexiones",
      status: "Estado",
    },
    toasts: {
      deleted: "Campaña eliminada con éxito",
    },
    tooltips: {
      edit: "Editar campaña",
      delete: "Eliminar campaña",
    },
    empty: {
      title: "No se encontró ninguna campaña",
      description: "Haz clic en \"Nueva Campaña\" para crear tu primera campaña de flujo",
    },
    fallbacks: {
      noName: "Nombre no definido",
    },
    noConnection: "Ninguna conexión",
    moreConnections: "{{count}} conexión(es) más",
    configuredPhrases: "{{count}} frase(s) configurada(s)",
  },
  dashboard: {
    toasts: {
      ticketInfoError: "Error al buscar información de los tickets",
    },
    heatmap: {
      title: "Heatmap de Atención",
      description: "Cantidad de atenciones iniciadas por día de la semana y hora.",
      hourRange: "{{start}}:00 a {{end}}:59",
      attendances: "{{count}} atención(es)",
      ticketDetails: "Ticket #{{ticketId}} | Contacto: {{contact}} | Número: {{number}} | Estado: {{status}} | Agente: {{user}}",
      ticketMeta: "Número: {{number}} | Estado: {{status}} | Agente: {{user}}",
      additionalTickets: "+ {{count}} ticket(s) adicional(es)",
      peak: "Pico en el período: {{count}} atención(es) iniciadas en una hora.",
      lower: "Menor",
      higher: "Mayor",
      dialogTitle: "{{day}} | {{hourRange}} | {{count}} atención(es)",
      noName: "Sin nombre",
      shortDays: {
        sunday: "Dom",
        monday: "Lun",
        tuesday: "Mar",
        wednesday: "Mié",
        thursday: "Jue",
        friday: "Vie",
        saturday: "Sáb",
      },
      days: {
        sunday: "Domingo",
        monday: "Lunes",
        tuesday: "Martes",
        wednesday: "Miércoles",
        thursday: "Jueves",
        friday: "Viernes",
        saturday: "Sábado",
      },
    },
  },
  users: {
    table: {
      avatar: "Avatar",
    },
    toasts: {
      chatCreated: "Chat creado con éxito!",
      chatsGenerated: "Chats generados con éxito!",
    },
    confirmations: {
      backfillChats: "¿Seguro que deseas generar chats para todos los usuarios existentes? Esto puede demorar y crear muchos chats.",
    },
  },
  signup: {
    form: {
      plan: "Plan",
    },
  },
  prompts: {
    toasts: {
      noPermissionRedirect: "¡Esta empresa no tiene permiso para acceder a esta página! Estamos redirigiéndote.",
    },
  },
  announcements: {
    toasts: {
      noPermissionRedirect: "¡Esta empresa no tiene permiso para acceder a esta página! Estamos redirigiéndote.",
    },
  },
  companies: {
    toasts: {
      noPermissionRedirect: "¡Esta empresa no tiene permiso para acceder a esta página! Estamos redirigiéndote.",
    },
  },
  queueIntegration: {
    toasts: {
      noPermissionRedirect: "¡Esta empresa no tiene permiso para acceder a esta página! Estamos redirigiéndote.",
    },
  },
});

mergeTranslations(messages.es.translations, {
  common: {
    understood: "Entendido",
    noName: "Sin nombre",
    error: "Error",
    table: {
      actions: "Acciones",
    },
  },
  contactListItems: {
    toasts: {
      bulkDeleted: "{{count}} contactos eliminados con éxito!",
      bulkDeleteError: "Error al eliminar contactos",
    },
    confirmationModal: {
      downloadExample: "Haz clic aquí para descargar la planilla de ejemplo.",
      deleteSelectedTitle: "¿Eliminar {{count}} contactos seleccionados?",
      deleteSelectedMessage: "¿Seguro que deseas eliminar los contactos seleccionados? Esta acción no se puede deshacer.",
    },
    bulk: {
      pageSelected: "Todos los {{count}} contactos de esta página fueron seleccionados.",
      selectAllList: "Seleccionar todos los {{count}} contactos de esta lista",
      allSelected: "Todos los {{count}} contactos de esta lista están seleccionados.",
      clearSelection: "Limpiar selección",
    },
    table: {
      photo: "Foto",
    },
    tooltips: {
      whatsappValid: "WhatsApp válido",
      whatsappInvalid: "WhatsApp inválido",
    },
    importProgress: {
      importing: "Importando contactos ({{percent}}%)",
      total: "Total en la planilla: {{count}}",
      toImport: "Serán importados: {{count}}",
      processed: "Procesados: {{count}}",
      imported: "Importados: {{count}}",
      existing: "Ya existentes: {{count}}",
      duplicated: "Duplicados: {{count}}",
      errors: "Con error: {{count}}",
      existingTitle: "Contactos ya existentes en la lista:",
      duplicatedTitle: "Contactos duplicados detectados:",
      errorTitle: "Contactos con error:",
      noExistingDetails: "No se devolvió ningún elemento detallado para los ya existentes.",
      noDuplicatedDetails: "No se devolvió ningún elemento detallado para mostrar, a pesar del conteo de duplicados.",
      noErrorDetails: "No se devolvió ningún elemento detallado para los errores.",
    },
  },
  contactNotes: {
    toasts: {
      added: "Observación agregada con éxito!",
      deleted: "Observación eliminada con éxito!",
    },
    confirmation: {
      deleteTitle: "Eliminar Registro",
      deleteMessage: "¿Realmente deseas eliminar este registro?",
    },
    editModal: {
      title: "Editar Observación",
      label: "Editar Observación",
    },
  },
  checkoutPage: {
    steps: {
      data: "Datos",
      customize: "Personalizar",
      review: "Revisar",
    },
    notFound: "No encontrado",
    total: "TOTAL",
    copied: "Copiado",
    copyPixQrCode: "Copiar código QR PIX",
    usersCount: "{{count}} Usuarios",
    connectionsCount: "{{count}} Conexión",
    decreaseUsers: "Disminuir usuarios",
    increaseUsers: "Aumentar usuarios",
    decreaseConnections: "Disminuir conexiones",
    increaseConnections: "Aumentar conexiones",
    toasts: {
      subscriptionSuccess: "Suscripción realizada con éxito, aguardando el pago",
      licenseRenewed: "Tu licencia fue renovada hasta {{date}}!",
    },
    form: {
      fullName: "Nombre completo*",
      lastName: "Apellido*",
      address: "Dirección*",
      city: "Ciudad*",
      state: "Estado*",
      document: "CPF/CNPJ*",
      country: "País*",
      useAddressForPayment: "Usar esta dirección para los datos de pago",
      nameOnCard: "Nombre en la tarjeta*",
      cardNumber: "Número de tarjeta*",
      expiryDate: "Fecha de vencimiento*",
      cvv: "CVV*",
    },
    validation: {
      fullNameRequired: "El nombre completo es obligatorio",
      lastNameRequired: "El apellido es obligatorio",
      addressRequired: "La dirección es obligatoria",
      cityRequired: "La ciudad es obligatoria",
      stateRequired: "El estado es obligatorio",
      zipcodeRequired: "El código postal es obligatorio",
      zipcodeInvalid: "Formato de código postal inválido",
      countryRequired: "El país es obligatorio",
      nameOnCardRequired: "El nombre en la tarjeta es obligatorio",
      cardNumberRequired: "El número de tarjeta es obligatorio",
      cardNumberInvalid: "El número de tarjeta no es válido (ej: 4111111111111)",
      expiryDateRequired: "La fecha de vencimiento es obligatoria",
      expiryDateInvalid: "La fecha de vencimiento no es válida",
      cvvRequired: "CVV es obligatorio",
      cvvInvalid: "CVV inválido (ej: 357)",
    },
    review: {
      paymentInfo: "Información de pago",
      email: "Email:",
      name: "Nombre:",
      document: "CPF/CNPJ:",
      planDetails: "Detalles del plan",
      users: "Usuarios: {{count}}",
      connections: "Conexión: {{count}}",
      queues: "Colas: {{count}}",
      billingMonthly: "Cobro: Mensual",
    },
  },
  messagesList: {
    emptyNewContact: "¡Saluda a tu nuevo contacto!",
    dropFileHere: "Suelta el archivo aquí",
    unsupportedMediaType: "Tipo de media no compatible",
    audioMessage: "Mensaje de audio",
  },
  floupSelector: {
    toasts: {
      stopped: "Follow UP interrumpido con éxito",
    },
    stopFollowUp: "Parar Follow UP",
    active: "Activo",
    nextSteps: "Próximos pasos:",
    infoTitle: "Información sobre Follow UP",
    selectFollowUp: "Seleccionar Follow UP",
    chooseTemplate: "Elegir template...",
    customTemplate: "personalizado",
    aboutTitle: "Sobre el Sistema Follow UP",
    aboutDescriptionPrefix: "El",
    aboutDescriptionSuffix: "permite crear flujos de mensajes y asignarlos a un contacto o ticket para ejecución automática.",
    aboutHint: "Selecciona un template activo para iniciar. Puedes interrumpirlo en cualquier momento.",
  },
  whatsAppModal: {
    defaultResponseFlow: {
      title: "Flujo de respuesta predeterminado",
      description: "La Respuesta Predeterminada se envía con cualquier carácter diferente de una palabra clave. ¡ATENCIÓN! Se disparará si la atención ya está cerrada.",
    },
  },
  whatsAppModalAdmin: {
    toasts: {
      clickSaveToRegister: "Haz clic en guardar para registrar los cambios",
    },
    tabs: {
      chatbot: "Chatbot",
    },
  },
  templateMetaModal: {
    title: "Templates de WhatsApp",
    searchPlaceholder: "Buscar Templates",
    language: "Idioma: {{language}}",
    templateContent: "Contenido del Template: {{content}}",
    category: "Categoría: {{category}}",
    selectedDetails: "Detalles del Template Seleccionado",
    name: "Nombre: {{name}}",
    content: "Contenido: {{content}}",
  },
  quickMessagesTable: {
    shortcut: "Atajo",
    message: "Mensaje",
  },
  contactListTable: {
    name: "Nombre",
    contacts: "Contactos",
  },
  queueOptions: {
    titlePlaceholder: "Título de la opción",
    undefinedTitle: "Título no definido",
    messagePlaceholder: "Escribe el texto de la opción",
  },
});

mergeTranslations(messages.es.translations, {
  avatarUpload: {
    errors: {
      unsupportedFormat: "Formato de archivo no compatible. Usa solo JPG, PNG, GIF o WebP.",
      fileTooLarge: "Archivo demasiado grande. Tamaño máximo: 5MB",
    },
    alt: {
      userAvatar: "Avatar del usuario",
    },
    changeAvatar: "Cambiar Avatar",
    uploadAvatar: "Subir Avatar",
  },
  notificationsVolume: {
    openNotifications: "Abrir notificaciones",
  },
  darkMode: {
    toggle: "Alternar modo oscuro",
  },
  ticketActionButtonsCustom: {
    toasts: {
      ticketClosed: "¡Ticket finalizado con éxito!",
    },
    buttons: {
      createNewTicket: "Crear Nuevo Ticket",
    },
    tooltips: {
      linkWallet: "Vincular a mi cartera",
      copyPhoneWithPrefix: "Copiar teléfono con prefijo ({{prefix}})",
    },
    aria: {
      userMenu: "Cuenta del usuario actual",
    },
  },
  speedDialButton: {
    openActionsMenu: "Abrir menú de acciones",
  },
  dashboard: {
    attendantsStatus: {
      online: "Online",
      offline: "Offline",
    },
  },
  wavoipCall: {
    connected: "Conectado",
    disconnected: "Desconectado",
    minimize: "Minimizar",
    enterNumber: "Escribe un número",
    subtitle: "Realiza llamadas por WhatsApp",
    incomingCall: "Llamada recibida",
    unknownNumber: "Número desconocido",
    callStatus: {
      inCall: "En llamada",
      connecting: "Conectando...",
      calling: "Llamando...",
    },
    errors: {
      numberTooShort: "Número demasiado corto",
      numberTooLong: "Número demasiado largo",
      invalidNumber: "Número inválido",
    },
  },
  login: {
    aria: {
      togglePasswordVisibility: "Alternar visibilidad de la contraseña",
    },
  },
  flowBuilder: {
    status: {
      active: "Activo",
      inactive: "Inactivo",
    },
    aria: {
      createFlow: "Crear flujo",
    },
  },
  chat: {
    aria: {
      mainMailboxFolders: "Carpetas principales del buzón",
      more: "Más",
    },
  },
  chatBots: {
    toasts: {
      saved: "Bot guardado con éxito",
      queueDeleted: "¡Cola eliminada con éxito!",
    },
    optionTypes: {
      text: "Texto",
      attendant: "Agente",
      queue: "Cola",
      integration: "Integración",
      file: "Archivo",
    },
    tooltips: {
      messageRequired: "El mensaje es obligatorio para seguir al siguiente nivel",
      messageRequiredContent: "Si el mensaje no está definido, el bot no continuará",
    },
  },
});

mergeTranslations(messages.es.translations, {
  campaignReport: {
    backButton: "Volver",
    fetchError: "Error al buscar datos del informe",
  },
  campaigns: {
    dialog: {
      form: {
        pendingTicketStatus: "Pendiente",
      },
    },
  },
  chatPopover: {
    deleteMessage: "¿Seguro que deseas eliminar este mensaje?",
  },
  compaies: {
    modal: {
      editTitle: "Editar Empresa",
    },
    table: {
      generateInvoice: "Generar Factura",
    },
  },
  connections: {
    table: {
      color: "Color",
    },
  },
  contactModal: {
    form: {
      assignWallet: "Cartera del Cliente",
      whatsapp: "Conexión de Origen: ",
    },
  },
  contacts: {
    loadMore: "Cargar Más",
    loading: "Cargando...",
    table: {
      wallet: "Cartera",
    },
  },
  dashboard: {
    cards: {
      activeTickets: "Tickets Activos",
      groups: "Grupos",
      passiveTickets: "Tickets Pasivos",
    },
  },
  fileModal: {
    form: {
      fileOptions: "Lista de archivos",
    },
  },
  languages: {
    "pt-BR": "Portugués",
  },
  mainDrawer: {
    listItems: {
      birthdaySettings: "Config. Cumpleaños",
      callHistorical: "Historial de Llamadas",
      files: "Lista de archivos",
      management: "Gestión",
      reports: "Informes",
    },
  },
  messageInput: {
    type: {
      template: "Template Meta",
    },
  },
  messageOptionsMenu: {
    cancelForward: "Cancelar",
  },
  messageVariablesPicker: {
    vars: {
      scheduledDate: "Fecha de Programación",
    },
  },
  messagesList: {
    header: {
      amount: "Valor de prospección",
      buttons: {
        disableIntegration: "Deshabilitar integración",
        greetingAcceptedMessage: "Debes configurar un mensaje de saludo al aceptar el ticket.",
      },
    },
  },
  notifications: {
    messageHidden: "Mensaje oculto",
    newMessage: "Nuevo mensaje de",
  },
  plans: {
    form: {
      public: "Público",
      trial: "Trial",
      trialDays: "Días Trial",
    },
    modal: {
      editTitle: "Editar Plan",
    },
  },
  queueIntegrationModal: {
    form: {
      typebotDelayMessage: "Intervalo (ms) entre mensajes",
      typebotKeywordRestart: "Palabra para reiniciar el flujo",
      typebotRestartMessage: "Mensaje al reiniciar la conversación",
    },
  },
  queueModal: {
    form: {
      randomizeImmediate: "Aleatorizar Automáticamente (Inmediato)",
      typeRandomMode: "Tipo de rotación",
    },
  },
  quickMessages: {
    global: "Global",
    hasMedia: "Con media",
    noQuickMessages: "No hay respuestas rápidas disponibles",
    noResultsFound: "No se encontraron respuestas rápidas para tu búsqueda",
    selectMessage: "Seleccionar Respuesta Rápida",
  },
  reports: {
    searchPlaceholder: "Buscar...",
  },
  scheduleModal: {
    buttons: {
      addSchedule: "Agregar programación",
    },
    form: {
      assinar: "Enviar Firma",
    },
  },
  settings: {
    settings: {
      options: {
        copyContactPrefix: "Prefijo para Copia de Contactos",
        copyContactPrefixPlaceholder: "Ej: COPIA_",
        open: "Abierto",
        pending: "Pendiente",
        removeAreaCode: "Eliminar código de área",
        removeCountryCode: "Eliminar código del país",
        removeNinthDigit: "Eliminar noveno dígito",
        transferredTicketStatus: "Estado del ticket al transferir con usuario",
      },
    },
  },
  showTicketLogModal: {
    options: {
      clientClosed: "El cliente cerró el ticket",
      redirect: "- redirigido",
    },
  },
  signup: {
    toasts: {
      disabled: "El registro de usuarios está deshabilitado por el momento. Inténtalo nuevamente más tarde.",
    },
  },
  tagModal: {
    form: {
      greetingMessageLane: "Mensaje de saludo de la lane",
      mediaFiles: "Media",
      nextLaneId: "Lane",
      rollbackLaneId: "Volver a la Lane después de retomar la atención",
      timeLane: "Tiempo en minutos para redirigir a la lane",
    },
  },
  tags: {
    table: {
      id: "ID",
    },
  },
  ticketInfo: {
    copyError: "Error al copiar teléfono",
    copyPhone: "Copiar teléfono",
    noPhone: "No hay teléfono disponible para copiar",
    phonecopied: "¡Teléfono copiado al portapapeles!",
    quickMessages: "Respuestas rápidas",
  },
  tickets: {
    messageHidden: "Mensaje oculto",
    notification: {
      messageHidden: "Mensaje oculto",
    },
  },
  ticketsList: {
    buttons: {
      kanbanActions: "Opciones de Kanban",
    },
  },
  ticketsManager: {
    buttons: {
      resolveAll: "Resolver Todos",
    },
  },
  triggerFlowModal: {
    cancel: "Cancelar",
    description: "Selecciona un flujo para ejecutar en este ticket. El ticket cambiará al estado 'chatbot' durante la ejecución.",
    error: "Error al disparar flujo",
    flowId: "ID del flujo",
    noFlows: "No se encontraron flujos activos",
    selectFlow: "Elige un flujo",
    selectedFlow: "Flujo seleccionado",
    success: "¡Flujo disparado con éxito!",
    title: "Disparar Flujo",
    trigger: "Disparar Flujo",
    triggering: "Disparando...",
  },
  userModal: {
    form: {
      allowConnections: "Permitir acciones en las conexiones",
      allowRealTime: "Ver Panel de Atenciones",
      allowSeeMessagesInPendingTickets: "Permitir ver tickets pendientes",
      showCampaign: "Ver campañas",
      showContacts: "Ver contactos",
      showFlow: "Ver automatizaciones",
    },
  },
  wallets: {
    wallet: "Cartera",
  },
  whatsappModal: {
    errorRatingMessage: "Es obligatorio informar un mensaje de evaluación cuando se utiliza NPS.",
    form: {
      business_id: "ID del negocio",
      collectiveVacationEnd: "Fecha final",
      collectiveVacationMessage: "Mensaje de vacaciones colectivas",
      collectiveVacationStart: "Fecha inicial",
      flowInactiveTime: "Tiempo en minutos para enviar el flujo de inactividad",
      isOficial: "Oficial",
      maxUseInactiveTime: "Enviar flujo de inactividad x veces",
      phone_number: "Número de teléfono",
      phone_number_id: "ID Número de teléfono",
      queueIdImportMessages: "Cola para importar los mensajes",
      send_token: "Token de envío",
      timeAwaitActiveFlow: "Tiempo para esperar la activación del flujo",
      timeToReturnQueue: "Tiempo para retornar a la cola en minutos",
      waba_id: "Waba ID",
    },
  },
});

mergeTranslations(messages.es.translations, {
  mainDrawer: {
    listItems: {
      globalSearch: "Búsqueda Global",
    },
  },
  bootLoader: {
    loadingSubtitle: "Cargando tu experiencia...",
    initializingApplication: "Inicializando aplicación...",
    loadingComponents: "Cargando componentes...",
    configuringInterface: "Configurando interfaz...",
    connectingServices: "Conectando servicios...",
    preparingSystem: "Preparando el sistema...",
    finishingLoading: "Finalizando carga...",
  },
  tagsContainer: {
    placeholder: "Etiquetas",
    loadingTags: "Cargando etiquetas...",
    noTagsFound: "No se encontró ninguna etiqueta. Escribe para crear una nueva.",
  },
  whitelabel: {
    loadingSettings: "Cargando configuraciones...",
  },
  billingEntitlements: {
    BILLING_RESOURCE_BLOCKED: "Recurso bloqueado por el plan.",
    PLAN_FEATURE_DISABLED: "Este recurso no está incluido en tu plan.",
    PLAN_LIMIT_REACHED: "Se alcanzó el límite del plan.",
    PLAN_USER_LIMIT_REACHED: "Tu plan alcanzó el límite de usuarios.",
    PLAN_CONNECTION_LIMIT_REACHED: "Tu plan alcanzó el límite de conexiones.",
    SUBSCRIPTION_NOT_ACTIVE: "Tu suscripción no está activa.",
    SUBSCRIPTION_SUSPENDED: "Tu suscripción está suspendida.",
    BILLING_MANUAL_REVIEW_REQUIRED: "Este acceso requiere revisión manual.",
    BILLING_STATUS_UNKNOWN: "El estado de facturación requiere revisión.",
    ENTITLEMENT_RESOLUTION_FAILED: "No fue posible validar el acceso ahora.",
    CAMPAIGN_WAITING_FOR_BILLING: "Tu campaña permanece en espera hasta regularizar el acceso.",
    SCHEDULE_WAITING_FOR_BILLING: "La programación permanece en espera de regularización de facturación."
  },
});

export { messages };
